// am — checkin/quickCheck/stepTracker blocks translated.
export const am = {
  "common": {
    "loading": "በመጫን ላይ...",
    "save": "አስቀምጥ",
    "cancel": "ሰርዝ",
    "delete": "አጥፋ",
    "edit": "አስተካክል",
    "close": "ዝጋ",
    "confirm": "አረጋግጥ",
    "back": "ተመለስ",
    "next": "ቀጥል",
    "submit": "ላክ",
    "search": "ፈልግ",
    "select": "ምረጥ",
    "or": "ወይም",
    "and": "እና",
    "note": "ማስታወሻ",
    "viewAll": "ሁሉንም እይ",
    "learnMore": "ተጨማሪ እወቅ",
    "getStarted": "ጀምር",
    "continue": "ቀጥል",
    "saving": "በማስቀመጥ ላይ…"
  },
  "nav": {
    "dashboard": "መነሻ",
    "nutrition": "ስርአተ-ምግብ",
    "family": "ቤተሰብ",
    "care": "አገልግሎቶች",
    "careShort": "አገልግሎቶች",
    "checkIn": "ክትትል",
    "insights": "ግንዛቤዎች",
    "trends": "ለውጦች",
    "habits": "ልምዶች",
    "medications": "መድሃኒቶች",
    "expertSupport": "የባለሙያ ድጋፍ",
    "profile": "መገለጫ",
    "healthHub": "የጤና ማዕከል",
    "support": "ድጋፍ",
    "wellness": "ደህንነት",
    "education": "ትምህርት",
    "community": "ማህበረሰብ",
    "preventiveHealth": "የቅድመ-መከላከል ጤና",
    "womensHealth": "የሴቶች ጤና",
    "reminders": "የጤና ማስታወሻዎች",
    "meals": "ምግቦች",
    "orders": "ትዕዛዞች",
    "subscription": "ምዝገባ",
    "logout": "ውጣ"
  },

  "navShort": {
    "dashboard": "መነሻ",
    "nutrition": "ምግብ",
    "family": "ቤተሰብ",
    "care": "አገልግሎት",
    "support": "ድጋፍ",
    "profile": "መገለጫ"
  },
  "auth": {
    "login": "ግባ",
    "register": "መለያ ክፈት",
    "logout": "ውጣ",
    "email": "ኢሜይል",
    "password": "የይለፍ ቃል",
    "name": "ሙሉ ስም",
    "forgotPassword": "የይለፍ ቃል ረሱ?",
    "noAccount": "መለያ የለዎትም?",
    "haveAccount": "መለያ አለዎት?",
    "signInHere": "እዚህ ይግቡ",
    "signUpHere": "እዚህ ይመዝገቡ",
    "welcomeBack": "እንኳን ደህና መጡ!",
    "getStarted": "እንጀምር",
    "biometricLogin": "በጣት አሻራ/በፊት ይግቡ",
    "biometricHelper": "የጣት አሻራን፣ Face IDን ወይም Windows Helloን ይጠቀሙ",
    "vendorLogin": "የአቅራቢ መግቢያ",
    "createOne": "አንድ መለያ ይፍጠሩ",
    "tagline": "ጤናዎን ይጠብቁ — በቀን አንድ ቀላል ክትትል በማድረግ።",
    "takes30s": "ከ30 ሰከንድ ያነሰ ጊዜ ይወስዳል",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "የይለፍ ቃልዎን ያስገቡ",
    "checking": "በማጣራት ላይ…",
    "continue": "ቀጥል",
    "secureMessage": "ደህንነቱ የተጠበቀ እና ሚስጥራዊ — መረጃዎ ጥበቃ ይደረግለታል",
    "biometricSoon": "በባዮሜትሪክ መግባት — በቅርቡ ይጀምራል",
    "sessionExpired": "የቆይታ ጊዜዎ አልቋል። ካቆሙበት ለመቀጠል እባክዎ እንደገና ይግቡ።",
    "showPassword": "የይለፍ ቃል አሳይ",
    "hidePassword": "የይለፍ ቃል ደብቅ",
    "vendor": {
      "title": "የአቅራቢ አጋር መግቢያ",
      "subtitle": "የእርስዎን የHealthLoop የአቅራቢ ዳሽቦርድ ይክፈቱ",
      "businessEmail": "የንግድ ኢሜይል",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "በመግባት ላይ...",
      "signIn": "ግባ",
      "notVendorYet": "ገና የአቅራቢ አጋር አልሆኑም?",
      "registerBusiness": "ንግድዎን ይመዝግቡ",
      "areYouUser": "ተጠቃሚ ነዎት?",
      "userLogin": "የተጠቃሚ መግቢያ",
      "welcomeBackToast": "እንኳን ደህና መጡ!",
      "genericError": "መግባት አልተሳካም። እባክዎ እንደገና ይሞክሩ።"
    },
    "admin": {
      "backToUserLogin": "የተጠቃሚ መግቢያ",
      "title": "የአስተዳዳሪ መግቢያ",
      "restrictedBadge": "የተገደበ",
      "tagline": "የHealthLoop ኦፕሬተር ኮንሶል — የአስተዳዳሪ መለያ ያስፈልጋል።",
      "emailLabel": "የአስተዳዳሪ ኢሜይል",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "የይለፍ ቃል",
      "passwordPlaceholder": "የአስተዳዳሪ ይለፍ ቃልዎን ያስገቡ",
      "signingIn": "በመግባት ላይ…",
      "submit": "ወደ አስተዳዳሪ ኮንሶል ይግቡ",
      "secureNote": "ደህንነቱ የተጠበቀ ግንኙነት · ምስጠራ ያለው ቆይታ",
      "restrictedTitle": "ይህ ቦታ ለአስተዳዳሪዎች ብቻ የተገደበ ነው።",
      "restrictedBody": "በመለያዎ ገብተዋል፣ ነገር ግን የአስተዳዳሪ መብት የለዎትም። በሌላ መለያ ለመሞከር ይውጡ ወይም ወደ ዋናው መተግበሪያ ይመለሱ።",
      "signOut": "ውጣ",
      "backToApp": "ወደ መተግበሪያው ተመለስ"
    }
  },
  "quickCheck": {
    "header": {
      "title": "ዛሬ ምን ይሰማዎታል?",
      "subtitle": "ፈጣን ክትትል — ከ60 ሰከንድ ያነሰ ጊዜ ይወስዳል"
    },
    "section1": {
      "title": "ዛሬ ምን አስተዋሉ?",
      "hint": "(የሚመለከተውን ሁሉ ይምረጡ)"
    },
    "environment": {
      "title": "የዛሬው አካባቢዎ",
      "hint": "አካባቢዎን እንድንረዳ ያግዙን"
    },
    "basicChecks": {
      "title": "ፈጣን መሠረታዊ ክትትል",
      "hint": "እንደ ፍላጎትዎ ነው ግን ቢሞላ ይጠቅማል"
    },
    "validation": {
      "pickOne": "እባክዎን ቢያንስ ለአንድ ጥያቄ መልስ ይስጡ"
    },
    "submit": {
      "cta": "የጤና ግንዛቤዬን አግኝ",
      "saving": "በማስቀመጥ ላይ...",
      "analyzing": "የጤና ሁኔታዎን በመተንተን ላይ...",
      "savedToast": "✅ ክትትልዎ ተቀምጧል! የጤና ሁኔታዎን በመተንተን ላይ..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "የእርምጃ መከታተያ",
      "subtitle": "ታማኝ እና የግል እንቅስቃሴ መከታተያ",
      "backToDashboard": "ወደ ዳሽቦርድ ይመለሱ"
    },
    "today": {
      "title": "የዛሬ እርምጃዎች",
      "goalProgress": "{{current}} / {{goal}} እርምጃዎች",
      "goalReached": "ግብዎ ላይ ደርሰዋል — ጥሩ ስራ!",
      "keepGoing": "ይቀጥሉ — በጥሩ ሁኔታ ላይ ነዎት።"
    },
    "streak": {
      "label": "የአሁኑ ተከታታይነት",
      "days": "{{count}} ቀን",
      "daysPlural": "{{count}} ቀናት"
    },
    "badges": {
      "title": "ባጆች",
      "empty": "ልምዱን ሲያዳብሩ ባጆችን ያገኛሉ።"
    },
    "reminders": {
      "title": "የእንቅስቃሴ ማሳሰቢያዎች",
      "hint": "ለረጅም ጊዜ ሲቀመጡ አጭር የእግር ጉዞ እንዲያደርጉ የሚረዱ ለስላሳ ማሳሰቢያዎች።",
      "enabled": "በርቷል",
      "disabled": "ጠፍቷል"
    },
    "insights": {
      "weeklyAverage": "የሳምንት አማካይ",
      "weeklyGoal": "የሳምንት ግብ"
    },
    "actions": {
      "connect": "የእርምጃ መቆጠሪያ ምንጭ ያገናኙ",
      "manualLog": "እርምጃዎችን በእጅ ይመዝግቡ",
      "changeGoal": "የዕለት ግብዎን ይለውጡ"
    }
  },
  "checkin": {
    "header": {
      "title": "የዕለት ተዕለት የጤና ክትትል",
      "subtitle": "ከ60 ሰከንድ ያነሰ ጊዜ ይወስዳል",
      "restDayLink": "ዛሬ ያን ያህል አልተሰማኝም"
    },
    "snapshot": {
      "title": "የእርስዎ ዳሽቦርድ ታድሷል",
      "healthScore": "የጤና ውጤት",
      "todayTasks": "የዛሬ ተግባራት",
      "dayStreak": "ተከታታይ ቀናት"
    },
    "resume": {
      "banner": "ካቆሙበት ቀጥለዋል",
      "startFresh": "አዲስ ይጀምሩ",
      "dismiss": "አሰናብት"
    },
    "progress": {
      "allSet": "ሁሉም ተዘጋጅቷል",
      "step": "ደረጃ {{current}} ከ {{total}}",
      "ariaLabel": "የዕለት ተዕለት ክትትል ሂደት፦ ከ{{total}} ክፍሎች {{done}} ተጠናቅቀዋል"
    },
    "insights": {
      "title": "የጤናዎ ግንዛቤዎች",
      "subtitle": "ለእርስዎ ዛሬ የተዘጋጀ",
      "insightForYou": "ለእርስዎ የሚሆን ግንዛቤ",
      "simpleActions": "ሊወስዷቸው የሚችሏቸው ቀላል እርምጃዎች",
      "whenToSeekHelp": "መቼ እርዳታ መፈለግ እንዳለብዎ",
      "nhsAdvice": "ካሳሰበዎት NHS 111 ወይም የቤተሰብ ዶክተርዎን ያማክሩ",
      "backToDashboard": "ወደ ዳሽቦርድ ይመለሱ",
      "newCheckIn": "አዲስ ክትትል",
      "disclaimer": "HealthLoop የጤና መረጃዎችን ይሰጣል እንጂ የሕክምና ምርመራ አይሰጥም።"
    },
    "restDay": {
      "title": "እረፍት የሂደቱ አካል ነው።",
      "body": "እርስዎ ዝግጁ ሲሆኑ ነገ እዚህ እንጠብቅዎታለን።",
      "streakNote": "የቀናት ቁጥርዎ አልተቀየረም — እሱም አብሮዎት እያረፈ ነው።",
      "backToDashboard": "ወደ ዳሽቦርድ ይመለሱ",
      "changedMind": "ለማንኛውም ክትትል ማድረግ እፈልጋለሁ።"
    },
    "feelings": {
      "title": "ዛሬ ምን ይሰማዎታል?",
      "hint": "የሚሰማዎትን ሁሉ ይምረጡ",
      "tired": "ድካም ይሰማኛል",
      "headache": "ራስ ምታት",
      "stressed": "ውጥረት ወይም ጫና",
      "pain": "የሰውነት ቁርጥማት ወይም ህመም",
      "okay": "ዛሬ ደህና ነኝ"
    },
    "basics": {
      "title": "መሠረታዊ ነገሮች",
      "sleepQ": "ትላንት ማታ ጥሩ እንቅልፍ ተኝተው ነበር?",
      "waterQ": "ዛሬ በቂ ውሃ ጠጥተዋል?",
      "foodQ": "ዛሬ በትክክል ተመግበዋል?",
      "activityQ": "ዛሬ ምን ያህል ንቁ ነበሩ?",
      "yes": "አዎ",
      "notReally": "ያም ያህል አይደለም",
      "notYet": "ገና አልሆነም",
      "notActive": "ንቁ አልነበርኩም",
      "lightActivity": "ቀለል ያለ እንቅስቃሴ",
      "active": "በጣም ንቁ"
    },
    "mind": {
      "title": "አእምሮ እና ጉልበት",
      "stressQ": "ዛሬ የውጥረት ደረጃዎ እንዴት ነው?",
      "moodQ": "ዛሬ ስሜትዎ እንዴት ነው?",
      "energyQ": "ዛሬ የጉልበትዎ ደረጃ እንዴት ነው?",
      "low": "ዝቅተኛ",
      "moderate": "መካከለኛ",
      "high": "ከፍተኛ",
      "neutral": "መደበኛ",
      "good": "ጥሩ",
      "okay": "ደህና"
    },
    "day": {
      "title": "ቀንዎ",
      "routineQ": "ዛሬ መደበኛ ልምዶችዎን ተከትለዋል?",
      "yes": "አዎ",
      "no": "አይ"
    },
    "environment": {
      "title": "የዛሬው አካባቢዎ",
      "describeQ": "አካባቢዎን እንዴት ይገልጹታል?",
      "comfortable": "😊 ምቹ",
      "slightlyUncomfortable": "😐 ትንሽ የማይመች",
      "challenging": "😓 ፈታኝ",
      "affectedQ": "አካባቢዎ በስሜትዎ ላይ ተጽዕኖ አሳድሯል?",
      "yes": "አዎ",
      "no": "አይ",
      "exposureLabel": "ተጋላጭነት (የሚመለከተውን ሁሉ ይምረጡ)",
      "heat": "🌡️ ሙቀት",
      "cold": "❄️ ቅዝቃዜ",
      "noise": "🔊 ጫጫታ",
      "dustSmoke": "💨 አቧራ ወይም ጭስ",
      "crowded": "👥 መጨናነቅ",
      "none": "✅ ምንም"
    },
    "submit": {
      "analyzing": "የጤና ሁኔታዎን በመተንተን ላይ...",
      "cta": "የጤና ግንዛቤዎቼን አሳይ"
    },
    "toast": {
      "savedFull": "ክትትልዎ ተቀምጧል! ዳሽቦርድዎ ታድሷል።",
      "savedShort": "ክትትልዎ ተቀምጧል።"
    }
  },
  "onboarding": {
    "welcome": "እንኳን ደህና መጡ",
    "completeSetup": "ምዝገባውን ያጠናቅቁ",
    "stepProgress": "ደረጃ {{step}} ከ {{total}}",
    "percentComplete": "{{percent}}% ተጠናቋል",
    "welcomeToast": "ወደ HealthLoop እንኳን ደህና መጡ! መገለጫዎ ተዘጋጅቷል።",
    "errorAgeRange": "እባክዎ የዕድሜ ክልልዎን ይምረጡ",
    "errorCountry": "እባክዎ ሀገርዎን ይምረጡ",
    "errorGoal": "እባክዎ ዋና የጤና ግብዎን ይምረጡ",
    "errorCuisine": "እባክዎ ቢያንስ አንድ ተመራጭ የምግብ አይነት ይምረጡ",
    "errorGeneric": "ምዝገባውን ማጠናቀቅ አልተቻለም። እባክዎ እንደገና ይሞክሩ።",
    "step1Title": "ወደ HealthLoop እንኳን ደህና መጡ! 👋",
    "step1Subtitle": "የጤና ጉዞዎን ለእርስዎ በሚስማማ መልኩ እናዘጋጅ",
    "ageRangeLabel": "የዕድሜ ክልልዎ ስንት ነው?",
    "genderLabel": "ጾታ (አማራጭ)",
    "gender_male": "ወንድ",
    "gender_female": "ሴት",
    "gender_non-binary": "ወንድም ሴትም ያልሆኑ",
    "gender_prefer_not_to_say": "ባለመናገር እመርጣለሁ",
    "step2Title": "የት ነው የሚኖሩት? 🌍",
    "step2Subtitle": "ይህ ከባህልዎ ጋር የሚጣጣሙ ምግቦችን ለመጠቆም ይረዳናል",
    "countryLabel": "ሀገርዎን ይምረጡ",
    "country_uk": "ዩናይትድ ኪንግደም",
    "country_nigeria": "ናይጄሪያ",
    "country_ghana": "ጋና",
    "country_kenya": "ኬንያ",
    "country_south_africa": "ደቡብ አፍሪካ",
    "country_usa": "ዩናይትድ ስቴትስ",
    "country_canada": "ካናዳ",
    "country_india": "ህንድ",
    "country_jamaica": "ጃማይካ",
    "country_other": "ሌላ",
    "step3Title": "ዋና ግብዎ ምንድነው? 🎯",
    "step3Subtitle": "ዋናውን የጤና ግብዎን ይምረጡ",
    "additionalGoals": "ሌሎች ግቦች አሉዎት? (አማራጭ)",
    "goal_weight_loss": "ክብደት መቀነስ",
    "goalDesc_weight_loss": "በጤናማ መንገድ ክብደት መቀነስ",
    "goal_weight_maintenance": "ክብደትን መጠበቅ",
    "goalDesc_weight_maintenance": "ባሉበት ክብደት መቀጠል",
    "goal_muscle_gain": "ጡንቻ መገንባት",
    "goalDesc_muscle_gain": "ጥንካሬ እና ጡንቻ ማግኘት",
    "goal_general_wellness": "አጠቃላይ ጤና",
    "goalDesc_general_wellness": "አጠቃላይ ጤናን ማሻሻል",
    "goal_better_sleep": "ጥሩ እንቅልፍ",
    "goalDesc_better_sleep": "የእንቅልፍ ጥራትን ማሻሻል",
    "goal_reduce_stress": "ውጥረትን መቀነስ",
    "goalDesc_reduce_stress": "ውጥረትን በተሻለ ሁኔታ መቆጣጠር",
    "goal_increase_energy": "ተጨማሪ ጉልበት",
    "goalDesc_increase_energy": "የበለጠ ንቁ ሆኖ መሰማት",
    "step4Title": "የምግብ ምርጫዎች 🍽️",
    "step4Subtitle": "የሚወዷቸውን የምግብ አይነቶች እና የምግብ ገደቦችን ይምረጡ",
    "cuisineLabel": "ተመራጭ የምግብ አይነቶች",
    "cuisineHint": "ቢያንስ አንድ ይምረጡ (ብዙ መምረጥ ይችላሉ)",
    "dietaryLabel": "የአመጋገብ ገደቦች (አማራጭ)",
    "diet_vegetarian": "ቬጀቴሪያን (አትክልት ተመጋቢ)",
    "diet_vegan": "ቪጋን",
    "diet_halal": "ሃላል",
    "diet_kosher": "ኮሸር",
    "diet_gluten_free": "ግሉተን-ነጻ",
    "diet_dairy_free": "የወተት ተዋጽኦ-ነጻ",
    "diet_pescatarian": "ፔስካቴሪያን",
    "step5Title": "የጤና ሁኔታዎች 🏥",
    "step5Subtitle": "አማራጭ — የተሻሉ ምክሮችን ለመስጠት ይረዳናል",
    "conditionsLabel": "ከእነዚህ ውስጥ ማንኛውም የጤና ሁኔታ አለብዎት?",
    "conditionsHint": "ይህ መረጃ ሚስጥራዊ ነው፤ አገልግሎቱን ለእርስዎ ለማስማማት ብቻ ጥቅም ላይ ይውላል",
    "condition_diabetes": "ስኳር በሽታ",
    "condition_hypertension": "ከፍተኛ የደም ግፊት",
    "condition_heart_disease": "የልብ ህመም",
    "condition_thyroid": "የታይሮይድ ችግር",
    "condition_celiac": "የሴሊያክ በሽታ",
    "condition_ibs": "የአንጀት መቆጣት (IBS)",
    "condition_none": "ምንም",
    "privacyTitle": "መረጃዎ የተጠበቀ ነው",
    "privacyBody": "የእርስዎ የግል መረጃ በምስጢር ተቀምጧል። ይህንን መረጃ የምንጠቀመው ለእርስዎ የሚስማሙ የምግብ ጥቆማዎችን፣ የጤና ምክሮችን እና ማሳሰቢያዎችን ለመስጠት ብቻ ነው። የእርስዎ መረጃ ያለፍቃድዎ ለሶስተኛ ወገን ፈጽሞ አይሰጥም።",
    "trackMedication": "መድሃኒቶቼን መከታተል እፈልጋለሁ",
    "specialistInterest": "ከባለሙያ ጋር መማከር እፈልጋለሁ",
    "welcomeTitle": "ወደ HealthLoop እንኳን ደህና መጡ! 👋",
    "welcomeSubtitle": "በጥቂት ቀላል እርምጃዎች የእርስዎን በሰው ሰራሽ አስተውሎት የታገዘ የመከላከያ ጤና እና የአኗኗር ዘይቤ መረጃ እናስተካክል",
    "stepLabel": "ደረጃ {{current}} ከ {{total}}",
    "skipForNow": "ለጊዜው ይለፍ",
    "skipToast": "የመገለጫ ዝግጅቱን በማንኛውም ጊዜ ከፕሮፋይልዎ ማጠናቀቅ ይችላሉ",
    "back": "ተመለስ",
    "next": "ቀጥል",
    "completing": "በማጠናቀቅ ላይ...",
    "complete": "ምዝገባውን አጠናቅ",
    "successToast": "እንኳን ወደ HealthLoop በደህና መጡ! መገለጫዎ አሁን ተስተካክሏል 🎉",
    "failureToast": "ምዝገባውን ማጠናቀቅ አልተቻለም",
    "validation": {
      "basicInfo": "እባክዎን ሁሉንም መሰረታዊ መረጃዎች ይሙሉ",
      "pickGoal": "እባክዎን ቢያንስ አንድ የጤና ግብ ይምረጡ",
      "pickPrimary": "እባክዎን ዋና ግብዎን ይምረጡ",
      "pickRegion": "ለእርስዎ የሚስማሙ የምግብ ጥቆማዎችን ለማግኘት እባክዎን ባህላዊ ክልልዎን ይምረጡ",
      "pickFocus": "እባክዎን ዋና የጤንነት ትኩረትዎን ይምረጡ"
    },
    "step1": {
      "title": "የጤና መገለጫዎ",
      "description": "የእርስዎን ግላዊ የጤና መረጃ ለመገንባት ይርዱን",
      "age": "ዕድሜ *",
      "agePlaceholder": "ምሳሌ፡ 30",
      "height": "ቁመት (ሴ.ሜ) *",
      "heightPlaceholder": "ምሳሌ፡ 170",
      "weight": "ክብደት (ኪ.ግ) *",
      "weightPlaceholder": "ምሳሌ፡ 70"
    },
    "step2": {
      "title": "የጤና ግቦችዎ",
      "description": "የሚመለከቱትን ሁሉ ይምረጡ፣ ከዚያ ዋና ግብዎን ይለዩ",
      "primaryLabel": "ዋና ግብዎን ይምረጡ *",
      "primaryBadge": "ዋና"
    },
    "step3": {
      "title": "🌍 የባህል እና የምግብ ምርጫዎች",
      "description": "የምግብ ጥቆማዎቻችንን ለእርስዎ እንዲስማሙ ለማድረግ ይርዱን",
      "regionLabel": "ባህላዊ ክልል *",
      "regionHint": "ለእርስዎ የሚስማሙ የምግብ ጥቆማዎችን ለማግኘት ባህላዊ ዳራዎን ይምረጡ",
      "countryLabel": "ሀገር (አማራጭ)",
      "countryPlaceholder": "ምሳሌ፡ ኢትዮጵያ፣ ኬንያ፣ ናይጄሪያ",
      "countryHint": "የበለጠ የተስማሙ ጥቆማዎችን ለማግኘት",
      "foodPrefLabel": "የምግብ አይነት ምርጫ"
    },
    "step4": {
      "title": "ዋና የጤንነት ትኩረት",
      "description": "በጣም ትኩረት መስጠት የሚፈልጉበትን ዘርፍ ይምረጡ"
    },
    "step5": {
      "title": "ምርጫዎችዎ",
      "description": "የ HealthLoop ተሞክሮዎን ያስተካክሉ",
      "trackMeds": "መድሃኒቶችን ይከታተሉ",
      "trackMedsHint": "በዕለታዊ ክትትልዎ ላይ የመድሃኒት መከታተያ እና ማስታወሻዎችን ያግብሩ",
      "specialist": "የባለሙያ ድጋፍ ይፈልጋሉ?",
      "specialistHint": "የጤንነት ባለሙያዎችን፣ የአመጋገብ ባለሙያዎችን እና የአእምሮ ጤና ባለሙያዎችን ያግኙ",
      "confidentialTitle": "ሚስጥራዊ ድጋፍ፦",
      "confidentialBody": "ሁሉም መረጃዎችዎ የተጠበቁ ናቸው፣ ጥቅም ላይ የሚውሉትም ግላዊ የመከላከያ ጤና ግንዛቤዎችን ለመስጠት ብቻ ነው።"
    },
    "step6": {
      "title": "የምግብ ዝግጅት ምርጫ",
      "description": "ከእርስዎ ፍላጎት እና የአመጋገብ ስርዓት ጋር የሚጣጣሙ ምግቦችን እንድንጠቁም ይርዱን",
      "cuisinesLabel": "የሚወዷቸው የምግብ አይነቶች (አማራጭ)",
      "cuisinesHint": "በጣም የሚወዷቸውን የምግብ አይነቶች ይምረጡ",
      "dietaryLabel": "የአመጋገብ ገደቦች (አማራጭ)",
      "dietaryHint": "የሚመለከቱዎትን ይምረጡ",
      "allergiesLabel": "የተለመዱ አለርጂዎች (አማራጭ)",
      "allergiesHint": "ማንኛውንም የምግብ አለርጂ ይምረጡ",
      "personalisedTitle": "የተመረጡ ምግቦች፦",
      "personalisedBody": "እነዚህን ምርጫዎች ለእርስዎ የሚስማሙ ምግቦችን ለመጠቆም እንጠቀምባቸዋለን። በኋላ ላይ በቅንብሮች ውስጥ መቀየር ይችላሉ።"
    },
    "healthGoals": {
      "better_sleep": "ጥሩ እንቅልፍ",
      "reduce_stress": "ውጥረትን መቀነስ",
      "increase_energy": "ጉልበት መጨመር",
      "weight_management": "ክብደት መቆጣጠር",
      "improve_fitness": "ሰውነትን ማጠንከር",
      "better_nutrition": "የተሻለ አመጋገብ",
      "mental_wellness": "የአእምሮ ጤንነት",
      "chronic_condition": "ጤናን መከታተል"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "የአእምሮ ጤና",
        "description": "በስሜት፣ በውጥረት እና በደህንነት ላይ ያተኩሩ"
      },
      "physical_fitness": {
        "label": "የአካል ብቃት",
        "description": "በእንቅስቃሴ፣ በብርታት እና በስፖርት ላይ ያተኩሩ"
      },
      "nutrition": {
        "label": "አመጋገብ",
        "description": "በምግብ አይነቶች እና በጤናማ አበላል ላይ ያተኩሩ"
      },
      "sleep": {
        "label": "የእንቅልፍ ጥራት",
        "description": "በእረፍት እና በእንቅልፍ ሁኔታ ላይ ያተኩሩ"
      },
      "stress_management": {
        "label": "ውጥረት መቆጣጠር",
        "description": "በመዝናናት እና ውጥረትን በመቀነስ ላይ ያተኩሩ"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "የምዕራብ አፍሪካ",
        "description": "የናይጄሪያ፣ የጋና፣ የሴኔጋል ምግቦች"
      },
      "east_african": {
        "label": "የምስራቅ አፍሪካ",
        "description": "የኢትዮጵያ፣ የኬንያ፣ የታንዛኒያ ምግቦች"
      },
      "north_african": {
        "label": "የሰሜን አፍሪካ",
        "description": "የሞሮኮ፣ የግብፅ ምግቦች"
      },
      "southern_african": {
        "label": "የደቡብ አፍሪካ",
        "description": "የደቡብ አፍሪካ ምግቦች"
      },
      "caribbean": {
        "label": "ካሪቢያን",
        "description": "የጃማይካ፣ የትሪኒዳድ ምግቦች"
      },
      "middle_eastern": {
        "label": "መካከለኛው ምስራቅ",
        "description": "የሊባኖስ፣ የፓለስቲና፣ የሶሪያ ምግቦች"
      },
      "south_asian": {
        "label": "የደቡብ እስያ",
        "description": "የህንድ፣ የፓኪስታን፣ የባንግላዲሽ ምግቦች"
      },
      "east_asian": {
        "label": "የምስራቅ እስያ",
        "description": "የቻይና፣ የጃፓን፣ የኮሪያ ምግቦች"
      },
      "southeast_asian": {
        "label": "የደቡብ ምስራቅ እስያ",
        "description": "የታይላንድ፣ የቬትናም፣ የኢንዶኔዥያ ምግቦች"
      },
      "western": {
        "label": "ምዕራባዊ",
        "description": "የአሜሪካ፣ የአውሮፓ ምግቦች"
      },
      "latin_american": {
        "label": "ላቲን አሜሪካ",
        "description": "የሜክሲኮ፣ የብራዚል፣ የአርጀንቲና ምግቦች"
      },
      "mediterranean": {
        "label": "ሜዲትራኒያን",
        "description": "የግሪክ፣ የጣሊያን፣ የስፔን ምግቦች"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "ባህላዊ",
        "description": "አብዛኛውን ጊዜ ከባህላዊ ክልልዎ የሚመነጩ ምግቦች"
      },
      "mixed": {
        "label": "ድብልቅ",
        "description": "የሀገር ውስጥ እና ዓለም አቀፍ ምግቦች ጥምረት"
      },
      "international": {
        "label": "ዓለም አቀፍ",
        "description": "የተለያዩ የዓለም ምግቦች"
      }
    },
    "cuisines": {
      "west_african": "ምዕራብ አፍሪካ",
      "caribbean": "ካሪቢያን",
      "mediterranean": "ሜዲትራኒያን",
      "asian": "እስያ",
      "western": "ምዕራባዊ",
      "indian": "ህንድ",
      "middle_eastern": "መካከለኛው ምስራቅ",
      "general": "ሁሉም ምግቦች"
    },
    "dietary": {
      "vegetarian": "አትክልት ተመጋቢ",
      "vegan": "ቪጋን",
      "pescatarian": "ፔስካታሪያን",
      "gluten_free": "ከግሉተን ነፃ",
      "dairy_free": "ከወተት ተዋጽኦ ነፃ",
      "low_carb": "ዝቅተኛ ካርቦሃይድሬት"
    },
    "allergies": {
      "nuts": "ለውዝ",
      "shellfish": "የባህር ምግቦች",
      "dairy": "የወተት ተዋጽኦ",
      "eggs": "እንቁላል",
      "soy": "አኩሪ አተር",
      "gluten": "ግሉተን"
    },
    "cuisine_nigerian": "የናይጄሪያ",
    "cuisine_ghanaian": "የጋና",
    "cuisine_senegalese": "የሴኔጋል",
    "cuisine_kenyan": "የኬንያ",
    "cuisine_ethiopian": "የኢትዮጵያ",
    "cuisine_moroccan": "የሞሮኮ",
    "cuisine_south_african": "የደቡብ አፍሪካ",
    "cuisine_jamaican": "የጃማይካ",
    "cuisine_trinidadian": "የትሪኒዳድ",
    "cuisine_lebanese": "የሊባኖስ",
    "cuisine_turkish": "የቱርክ",
    "cuisine_greek": "የግሪክ",
    "cuisine_italian": "የጣሊያን",
    "cuisine_french": "የፈረንሳይ",
    "cuisine_british": "የብሪታንያ",
    "cuisine_indian_south": "የደቡብ ህንድ",
    "cuisine_indian_north": "የሰሜን ህንድ",
    "cuisine_pakistani": "የፓኪስታን",
    "cuisine_japanese": "የጃፓን",
    "cuisine_chinese": "የቻይና",
    "cuisine_korean": "የኮሪያ",
    "cuisine_vietnamese": "የቪየትናም",
    "cuisine_thai": "የታይላንድ",
    "cuisine_filipino": "የፊሊፒንስ",
    "cuisine_american": "የአሜሪካ",
    "cuisine_mexican": "የሜክሲኮ",
    "cuisine_brazilian": "የብራዚል",
    "cuisine_peruvian": "የፔሩ"
  },
  "dashboard": {
    "welcome": "እንኳን ደህና መጡ",
    "greeting": "ሰላም",
    "goodMorning": "እንኳን አደረሰዎት",
    "goodAfternoon": "እንደምን ዋሉ",
    "goodEvening": "እንደምን አመሹ",
    "tagline": "ትናንሽ ጤናማ እርምጃዎች ዘላቂ ለውጥ ያመጣሉ",
    "microcopy": "የጤና ጉዞዎ ዋጋ አለው።",
    "welcomeSubtitleMorning1": "ቀኑን በሰላም ይጀምሩ።",
    "welcomeSubtitleMorning2": "ጠዋት ላይ እዚህ በመገኘትዎ ደስተኞች ነን።",
    "welcomeSubtitleMorning3": "ትናንሽ ነገሮች ትልቅ ለውጥ ያመጣሉ።",
    "welcomeSubtitleAfternoon1": "ቀኑ ጥሩ እየሆነ እንደሆነ ተስፋ እናደርጋለን።",
    "welcomeSubtitleAfternoon2": "ወደ HealthLoop እንኳን ደህና መጡ።",
    "welcomeSubtitleAfternoon3": "ትንሽ እረፍት ይውሰዱ — በጥሩ ሁኔታ ላይ ነዎት።",
    "welcomeSubtitleEvening1": "ከእርስዎ ጋር ቀኑን በማጠቃለል ላይ ነን።",
    "welcomeSubtitleEvening2": "መልካም ምሽት።",
    "welcomeSubtitleEvening3": "ለዚህ ምሽት እንኳን ደህና መጡ።",
    "title": "የእርስዎ የቅድመ-መከላከል ጤና መረጃ መድረክ",
    "subtitle": "ችግሮች ሳይባባሱ ይከታተሉ፣ ይማሩ እና እርምጃ ይውሰዱ",
    "summary": "የጤና መረጃዎ ማጠቃለያ",
    "summaryDesc": "በመከላከል፣ በትምህርት እና በደህንነት ዙሪያ ያሉ ወቅታዊ መረጃዎች",
    "comprehensiveSupport": "በመከላከል፣ በትምህርት እና በደህንነት ዙሪያ አጠቃላይ ድጋፍ",
    "todayCheckIn": "የዛሬ ክትትል",
    "quickActions": "ፈጣን ተግባራት",
    "healthOverview": "አጠቃላይ የጤና ሁኔታ",
    "recentActivity": "የቅርብ ጊዜ እንቅስቃሴ",
    "viewAll": "ሁሉንም እይ",
    "preventiveHealth": "የቅድመ-መከላከል ጤና",
    "preventiveHealthDesc": "የዕለት ተዕለት ክትትል እና የቅድመ ማስጠንቀቂያዎች",
    "education": "ትምህርት",
    "educationDesc": "በመረጃ የተደገፉ የጤና ጽሁፎች እና የባለሙያ መመሪያዎች",
    "engagement": "ተሳትፎ",
    "engagementDesc": "የማህበረሰብ ውድድሮች፣ የልምድ ክትትል እና ማህበራዊ ድጋፍ",
    "wellness": "ደህንነት",
    "wellnessDesc": "ዘመናዊ ስርአተ-ምግብ እና የኑሮ ዘይቤ ሚዛን",
    "todaysInsight": "የዛሬው ግንዛቤ",
    "wellnessScore": "የደህንነት ውጤት",
    "healthStreak": "የጤና ቀጣይነት",
    "days": "ቀናት",
    "logHealth": "ጤናን መዝግብ",
    "getEducated": "እውቀት ያግኙ",
    "communityChallenge": "የማህበረሰብ ውድድር",
    "checkWellness": "ደህንነትን አረጋግጥ",
    "verified": "የተረጋገጠ",
    "joinCommunity": "ማህበረሰቡን ይቀላቀሉ",
    "personalizedPlan": "የተዘጋጀ ዕቅድ",
    "score": "ውጤት",
    "checkIns": "ክትትሎች",
    "habits": "ልምዶች",
    "preventive": "መከላከያ",
    "healthMetrics": "የጤና መለኪያዎች",
    "trackMetrics": "መለኪያዎችን ይከታተሉ",
    "startTracking": "ክትትል ጀምር",
    "logMetrics": "መለኪያዎችን መዝግብ",
    "dailyInsight": "የዕለት ግንዛቤ",
    "learnAbout": "ዛሬ ስለ ቅድመ-መከላከል ጤና ይማሩ",
    "articlesAvailable": "ጽሁፎች ይገኛሉ",
    "browseArticles": "ጽሁፎችን ፈልግ",
    "currentStreak": "ያሉበት ቀጣይነት",
    "keepGoing": "ይቀጥሉበት!",
    "startStreak": "ቀጣይነትዎን ይጀምሩ",
    "checkIn": "ክትትል ያድርጉ",
    "nutritionPlan": "የአመጋገብ ዕቅድ",
    "mealsPlanned": "የታቀዱ ምግቦች",
    "viewPlan": "ዕቅዱን እይ",
    "planYourWeek": "ሳምንቱን ያቅዱ",
    "moodStress": "ስሜት እና ውጥረት",
    "howFeeling": "ስሜትዎ እንዴት ነው?",
    "logWellness": "ደህንነትን መዝግብ",
    "medications": "መድሃኒቶች",
    "noMeds": "የተመዘገበ መድሃኒት የለም",
    "addMedications": "መድሃኒቶችዎን ይጨምሩ",
    "daysTracked": "የተከታተሉባቸው ቀናት",
    "noHabits": "እስካሁን ምንም ልምድ የለም",
    "startTrackingHabits": "ልምዶችን መከታተል ይጀምሩ",
    "insights": "ግንዛቤዎች",
    "noInsights": "እስካሁን ምንም ግንዛቤ የለም",
    "completeFirstPlan": "የመጀመሪያውን ዕቅድ ያጠናቅቁ",
    "noCheckIns": "እስካሁን ምንም ክትትል የለም",
    "startFirstCheckIn": "የመጀመሪያውን ክትትል ይጀምሩ"
  },
  "support": {
    "title": "ድጋፍ",
    "subtitle": "መልሶችን ያግኙ፣ ያግኙን ወይም ችግርን ያሳውቁ",
    "backToSettings": "ወደ ቅንብሮች ተመለስ",
    "privacyBanner": "የድጋፍ ጥያቄዎች በምስጢር ይያዛሉ። የጤና መረጃዎ ደህንነቱ የተጠበቀ ነው።",
    "section1": "ክፍል 1",
    "section2": "ክፍል 2",
    "section3": "ክፍል 3",
    "section4": "ክፍል 4",
    "navHelpCenter": "የእርዳታ ማዕከል",
    "navContact": "ድጋፍ ሰጪን አግኝ",
    "navHealth": "የጤና አገልግሎቶች",
    "navTechnical": "የቴክኒክ ድጋፍ",
    "helpCenterTitle": "የእርዳታ ማዕከል",
    "helpCenterSubtitle": "የተለመዱ ጥያቄዎችን ፈልገው ፈጣን መልስ ያግኙ።",
    "contactTitle": "ድጋፍ ሰጪን አግኝ",
    "contactSubtitle": "በሚመርጡት መንገድ ቡድናችንን ያግኙ።",
    "healthServicesTitle": "የጤና አገልግሎቶች",
    "healthServicesSubtitle": "ከመድሃኒት ክትትል እና ከጤና ባለሙያዎች ጋር ይገናኙ።",
    "technicalTitle": "የቴክኒክ ድጋፍ",
    "technicalSubtitle": "የቴክኒክ ችግሮችን በዝርዝር ያሳውቁ።",
    "searchPlaceholder": "የተለመዱ ጥያቄዎችን ፈልግ…",
    "liveChat": "የቀጥታ ውይይት",
    "emailUs": "ኢሜይል ይላኩልን",
    "callBack": "ስልክ እንዲደወልልዎ ቀጠሮ ይያዙ",
    "sendMessage": "መልዕክት ይላኩ",
    "medicationTracking": "የመድሃኒት ክትትል",
    "specialistAccess": "ባለሙያ ማግኘት",
    "videoConsultation": "የቪዲዮ ምክክር",
    "reportBug": "ችግርን አሳውቅ",
    "yourName": "ስምዎ",
    "yourEmail": "ኢሜይልዎ",
    "subject": "ጉዳዩ",
    "message": "መልዕክት",
    "phone": "ስልክ",
    "description": "መግለጫ",
    "submit": "ላክ",
    "successTitle": "መልዕክቱ ተልኳል",
    "successDescription": "በ 24–48 ሰዓታት ውስጥ ምላሽ እንሰጣለን።",
    "healthDisclaimer": "ለአደጋ ጊዜ የጤና ችግሮች በአቅራቢያዎ የሚገኝ የድንገተኛ አገልግሎትን ያግኙ። HealthLoop የሙያ የጤና እንክብካቤ ምትክ አይደለም።"
  },
  "nutrition": {
    "smartNutrition": "ዘመናዊ ስርአተ-ምግብ",
    "basedOnGoal": "በግብዎ መሰረት:",
    "personalizedData": "በቅርብ የጤና መረጃዎ ላይ ተመስርቶ የተዘጋጀ",
    "evidenceBased": "እንደ ቅድመ-መከላከል ጤና ዕቅድዎ አካል የሆነ ሳይንሳዊ ስርአተ-ምግብ",
    "todaysMealSuggestions": "የዛሬ የምግብ ጥቆማዎች",
    "customize": "አስተካክል",
    "breakfast": "ቁርስ",
    "lunch": "ምሳ",
    "dinner": "እራት",
    "loadingBreakfast": "ቁርስ በመጫን ላይ...",
    "loadingLunch": "ምሳ በመጫን ላይ...",
    "loadingDinner": "እራት በመጫን ላይ...",
    "cal": "ካሎሪ",
    "protein": "ፕሮቲን",
    "swapMeal": "ምግብ ቀይር",
    "healthyOptionsNearYou": "በአቅራቢያዎ ያሉ ጤናማ አማራጮች",
    "enableLocation": "የመገኛ ቦታ ፍቃድ ስጥ",
    "view": "እይ",
    "discoverOptions": "በአቅራቢያዎ ያሉ ጤናማ ምግብ ቤቶችን፣ ሱቆችን እና አቅራቢዎችን ያግኙ",
    "cuisinesSelected": "የተመረጡ የምግብ አይነቶች",
    "cuisineSelected": "የተመረጠ የምግብ አይነት",
    "dietaryPrefs": "የአመጋገብ ምርጫዎች",
    "dietaryPref": "የአመጋገብ ምርጫ",
    "customizeMeals": "ምግቦችን አስተካክል",
    "subtitleAdaptive": "ለጤና ግብዎ የሚሆን ከባህል ጋር የተጣጣመ የምግብ ዕቅድ",
    "hideFavorites": "የተመረጡትን ደብቅ",
    "viewFavorites": "የተመረጡትን እይ",
    "customizeMealsLegacy": "ምግቦችን ከባህልዎ እና ከአመጋገብ ፍላጎትዎ ጋር እንዲጣጣሙ ያድርጉ",
    "viewFullPlan": "ሙሉ ዕቅዱን እይ",
    "exploreRecipes": "ምግብ አሰራሮችን ፈልግ"
  },
  "location": {
    "permissionTitle": "በአቅራቢያዎ ያሉ ጤናማ አማራጮችን ያግኙ",
    "permissionDesc": "ከጤና ግብዎ ጋር የሚሄዱ ምግብ ቤቶችን እና ሱቆችን ለመጠቆም ጥቅም ላይ ይውላል።",
    "howToEnable": "እንዴት እንደሚፈቀድ:",
    "step1": "በመፈለጊያ አሞሌው ላይ ያለውን የቁልፍ ምልክት 🔒 ይጫኑ",
    "step2": "የመገኛ ቦታ (Location) ፍቃድን ይፈልጉ",
    "step3": "ወደ \"ፍቀድ\" (Allow) ይቀይሩ",
    "step4": "ገጹን ያድሱ",
    "refreshPage": "ገጹን አድስ",
    "allowLocation": "መገኛ ቦታ ፍቀድ",
    "notNow": "አሁን አይደለም",
    "denied": "የመገኛ ቦታ ፍቃድ ተከልክሏል። በአቅራቢያ ያሉ አማራጮችን ለማየት ፍቃድ መስጠት አለብዎት።",
    "unavailable": "የመገኛ ቦታ መረጃ አሁን ማግኘት አልተቻለም። እባክዎ የስልክዎን ቅንብር ያረጋግጡ።",
    "error": "መገኛ ቦታዎን ማግኘት አልተቻለም። እባክዎ እንደገና ይሞክሩ።",
    "unsupported": "የእርስዎ መፈለጊያ (browser) የመገኛ ቦታ አገልግሎትን አይደግፍም። Chrome ወይም Safari ይጠቀሙ።",
    "accessRequired": "የመገኛ ቦታ ፍቃድ ያስፈልጋል"
  },
  "womensHealth": {
    "title": "የሴቶች ጤና",
    "description": "የወር አበባ ዑደትዎን ይከታተሉ እና በወቅቱ የሚሰማዎትን ምልክቶች ይመዝግቡ",
    "cycleTracking": "የዑደት ክትትል",
    "symptomLogging": "የምልክቶች ምዝገባ",
    "phaseInsights": "የዑደት ግንዛቤዎች",
    "logPeriod": "የወር አበባ መዝግብ",
    "logSymptoms": "ምልክቶችን መዝግብ",
    "insights": "ግንዛቤዎች",
    "tips": "የጤና ምክሮች",
    "overview": "አጠቃላይ እይታ",
    "history": "ታሪክ",
    "startTracking": "ዑደትዎን መከታተል ይጀምሩ"
  },
  "profile": {
    "title": "መገለጫ",
    "personalInfo": "የግል መረጃ",
    "healthProfile": "የጤና መገለጫ",
    "preferences": "ምርጫዎች",
    "language": "ቋንቋ",
    "selectLanguage": "ቋንቋ ይምረጡ",
    "notifications": "ማሳሰቢያዎች",
    "privacy": "ግላዊነት",
    "security": "ደህንነት",
    "quickAccess": "ፈጣን መዳረሻ",
    "editProfile": "መገለጫን አስተካክል",
    "viewStats": "መረጃዎችን እይ",
    "backToDashboard": "ወደ መነሻ ተመለስ",
    "womensHealthTitle": "የሴቶች ጤና",
    "womensHealthDesc": "የዑደት ክትትል እና የደህንነት ምክሮች",
    "healthRemindersTitle": "የጤና ማስታወሻዎች",
    "healthRemindersDesc": "ማሳሰቢያዎችዎን ያስተካክሉ",
    "manageRemindersDesc": "የማስታወሻ ምርጫዎችዎን እና ማሳሰቢያዎችን ያስተካክሉ",
    "healthPatternAlerts": "የጤና ሁኔታ ማሳወቂያዎች",
    "supportHelp": "ድጋፍ እና እርዳታ",
    "supportHelpDesc": "እርዳታ ያግኙ ወይም ችግሮችን ያሳውቁ",
    "admin": "አስተዳዳሪ",
    "adminDesc": "የአጠቃቀም መረጃዎችን እይ",
    "giveFeedback": "አስተያየት ይስጡ",
    "giveFeedbackDesc": "ስለ HealthLoop ያለዎትን ተሞክሮ ያካፍሉ",
    "reportProblem": "ችግርን ያሳውቁ",
    "reportProblemDesc": "ችግሮችን እንድንፈታ ያግዙን",
    "manageHealthInfo": "ለተሻለ ግንዛቤ የቅድመ-መከላከል ጤና መረጃዎን ያስተካክሉ",
    "basicInformation": "መሰረታዊ መረጃ",
    "fullName": "ሙሉ ስም",
    "email": "ኢሜይል",
    "dateOfBirth": "የትውልድ ቀን",
    "gender": "ጾታ",
    "height": "ቁመት (ሴ.ሜ)",
    "weight": "ክብደት (ኪ.ግ)",
    "medicalConditions": "የጤና ሁኔታዎች",
    "allergies": "አለርጂዎች",
    "personalHealth": "የግል ጤና",
    "addCondition": "የጤና ሁኔታ ይጨምሩ",
    "addAllergy": "አለርጂ ይጨምሩ",
    "saveChanges": "ለውጦችን አስቀምጥ",
    "saving": "በማስቀመጥ ላይ...",
    "privacyMessage": "የጤና መረጃዎ በምስጢር የተጠበቀ ነው"
  },
  "settings": {
    "title": "ቅንብሮች",
    "general": "ጠቅላላ",
    "account": "መለያ",
    "appearance": "ገጽታ",
    "languageSettings": "የቋንቋ ቅንብሮች",
    "changeLanguage": "ቋንቋ ይቀይሩ",
    "languageNote": "አዲስ ቋንቋ ሲመርጡ በይነገጹ ወዲያውኑ ይለወጣል። የአፍሪካ እና አዲስ የተጨመሩ ቋንቋዎች በ 'Starter' ምልክት ተለይተዋል — ይህም በኮምፒውተር የተተረጎሙ እና የአፍ መፍቻ ተናጋሪዎች ማረጋገጫ የሚጠብቁ መሆናቸውን ያሳያል።",
    "languageUpdated": "ቋንቋው በተሳካ ሁኔታ ተቀይሯል",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "በኮምፒውተር የተተረጎመ — በአፍ መፍቻ ተናጋሪ ግምገማ እየተደረገበት ነው።",
    "regions": {
      "global": "ዓለም አቀፍ",
      "european": "የአውሮፓ ቋንቋዎች",
      "middleEastern": "የመካከለኛው ምስራቅ ቋንቋዎች",
      "asian": "የእስያ ቋንቋዎች",
      "african": "የአፍሪካ ቋንቋዎች"
    }
  },
  "search": {
    "triggerLabel": "HealthLoopን ይፈልጉ",
    "triggerHint": "ለምሳሌ፦ \"እርምጃዎች\"፣ \"መድኃኒት ቤት\" ወይም \"እርግዝና\"",
    "triggerAriaLabel": "አጠቃላይ ፍለጋን ይክፈቱ",
    "placeholder": "ባህሪያትን፣ መከታተያዎችን፣ ድጋፎችን ይፈልጉ...",
    "inputAriaLabel": "የHealthLoop ባህሪያትን ይፈልጉ",
    "modalAriaLabel": "HealthLoopን ይፈልጉ",
    "close": "ዝጋ",
    "clear": "አጽዳ",
    "clearAriaLabel": "ፍለጋውን አጽዳ",
    "recentSearches": "የቅርብ ጊዜ ፍለጋዎች",
    "tryFor": "ይህንን ለመፈለግ ይሞክሩ",
    "findFeatures": "ማንኛውንም ባህሪ በሰከንዶች ውስጥ ያግኙ።",
    "searchAcross": "በእነዚህ ውስጥ ይፈልጉ",
    "and": "እና",
    "sections": {
      "home": "መነሻ",
      "nutrition": "ሥርዓተ ምግብ",
      "family": "ቤተሰብ",
      "services": "አገልግሎቶች",
      "support": "ድጋፍ",
      "profile": "መገለጫ"
    },
    "noMatchesFor": "ለ\"{{query}}\" የተገኘ ውጤት የለም",
    "trySimpler": "እንደ እርምጃዎች፣ ሥርዓተ ምግብ ወይም ስፔሻሊስት ያሉ ቀላል ቃላትን ይጠቀሙ።",
    "comingSoonBadge": "በቅርቡ የሚመጣ",
    "escToClose": "ለመዝጋት",
    "resultSingular": "{{count}} ውጤት",
    "resultPlural": "{{count}} ውጤቶች",
    "searchAcrossApp": "በመላው መተግበሪያው ውስጥ ይፈልጉ"
  },
  "familyMember": {
    "confirmRemove": "{{name}} ከቤተሰብ ጤና ክትትል ይወገድ?",
    "removed": "{{name}} ከቤተሰብ ተወግዷል",
    "removeFailed": "አባልን ማስወገድ አልተቻለም",
    "viewDetails": "ዝርዝሮችን ይመልከቱ",
    "edit": "ያስተካክሉ",
    "remove": "አስወግድ",
    "yearsSuffix": "ዓመታት",
    "healthGoalsLabel": "የጤና ግቦች፦",
    "moreSuffix": "ተጨማሪ",
    "activeInsights": "ንቁ ግንዛቤዎች",
    "viewAllInsights": "ሁሉንም {{count}} ግንዛቤዎች ይመልከቱ →",
    "viewFullProfile": "ሙሉ የጤና መገለጫን ይመልከቱ",
    "lifeStage": {
      "infant": "ሕፃን (0-2)",
      "toddler": "ታዳጊ (2-5)",
      "child": "ልጅ (6-12)",
      "adolescent": "ወጣት (13-17)",
      "adult": "አዋቂ (18-59)",
      "senior": "አዛውንት (60+)",
      "unknown": "ያልታወቀ"
    }
  },
  "profileDeep": {
    "backToDashboard": "ወደ ዋናው ገጽ ተመለስ",
    "profileCompletion": "የመገለጫ ሙላት",
    "healthSummary": "የጤና ማጠቃለያ",
    "sectionA": "ክፍል ሀ",
    "sectionB": "ክፍል ለ",
    "sectionC": "ክፍል ሐ",
    "sectionD": "ክፍል መ",
    "personalDetails": "የግል መረጃዎች",
    "healthInformation": "የጤና መረጃ",
    "accountSettings": "የመለያ ቅንብሮች",
    "fullName": "ሙሉ ስም",
    "email": "ኢሜይል",
    "dob": "የትውልድ ቀን",
    "gender": "ጾታ",
    "genderPlaceholder": "ለምሳሌ፦ ሴት፣ ወንድ",
    "height": "ቁመት (በሴንቲ ሜትር)",
    "heightPlaceholder": "ለምሳሌ፦ 170",
    "weight": "ክብደት (በኪሎግራም)",
    "weightPlaceholder": "ለምሳሌ፦ 70",
    "allergies": "አለርጂዎች",
    "allergiesPlaceholder": "ለምሳሌ፦ የኦቾሎኒ አለርጂ",
    "medicalConditions": "የጤና ሁኔታዎች",
    "conditionsPlaceholder": "ለምሳሌ፦ የደም ግፊት",
    "medications": "የሚወሰዱ መድኃኒቶች",
    "medicationsPlaceholder": "ለምሳሌ፦ ሊሲኖፕሪል 10mg፣ በቀን አንድ ጊዜ",
    "emergencyContact": "የአደጋ ጊዜ ተጠሪ",
    "emergencyOptional": "(ካለዎት)",
    "emergencyPlaceholder": "ለምሳሌ፦ እናቴ +251-911-000000",
    "emergencyNote": "ይህ መረጃ የሚጋራው እርስዎ ሲፈቅዱ ለባለሙያ ብቻ ነው።",
    "saveChanges": "ለውጦችን አስቀምጥ",
    "saving": "በማስቀመጥ ላይ…",
    "editProfile": "መገለጫ አድስ",
    "cancelEditing": "ለውጡን ሰርዝ",
    "healthScore": "የጤና ነጥብ",
    "streak": "የቀናት ሰንሰለት",
    "streakDays": "{{n}} ቀናት",
    "memberSince": "አባል የሆኑት፦",
    "remindersActive": "ማሳሰቢያዎች ንቁ ናቸው",
    "conditionsTracked": "የሚከታተሉ ሁኔታዎች",
    "nextAgenda": "ቀጣይ ተግባር",
    "notificationsReminders": "ማሳሰቢያዎች እና አስታዋሾች",
    "notificationsRemindersDesc": "የጤና ማሳሰቢያ ሰዓቶችን እና መንገዶችን ያስተካክሉ",
    "emailNudges": "የኢሜይል ማሳሰቢያዎች",
    "emailNudgesDesc": "ለስላሳ ማሳሰቢያዎች እና ሳምንታዊ ማጠቃለያዎች",
    "on": "በርቷል",
    "paused": "ቆሟል",
    "privacySecurity": "ግላዊነት እና ደህንነት",
    "privacySecurityDesc": "መለያዎ ደህንነቱ የተጠበቀ እንዲሆን የይለፍ ቃልዎን ያዘምኑ",
    "preferencesTitle": "ምርጫዎች",
    "preferencesDesc": "ቋንቋ፣ አካባቢ እና የግል ምርጫዎች",
    "supportHelp": "ድጋፍ እና እርዳታ",
    "supportHelpDesc": "መልሶችን ያግኙ እና እኛን ያነጋግሩ",
    "giveFeedback": "አስተያየት ይስጡ",
    "giveFeedbackDesc": "ምን ማሻሻል እንዳለብን ይንገሩን",
    "reportProblem": "ችግር ያሳውቁ",
    "reportProblemDesc": "እንከን አግኝተዋል? ያሳውቁን",
    "adminInsights": "የአስተዳዳሪ መረጃዎች",
    "adminInsightsDesc": "የተሳትፎ ትንታኔዎች",
    "adminBadge": "አስተዳዳሪ",
    "shareWithClinician": "ለጤና ባለሙያ ያጋሩ",
    "shareWithClinicianDesc": "ለማንበብ ብቻ የሚያገለግል ማጠቃለያ · በራሱ ጊዜ የሚጠፋ · በማንኛውም ጊዜ መሰረዝ የሚቻል",
    "share": "አጋራ",
    "profileMayBeOutOfDate": "የመገለጫ መረጃው ወቅታዊ ላይሆን ይችላል",
    "profileMayBeOutOfDateDesc": "የተሻለ የጤና መረጃ ለማግኘት መረጃዎን ወቅታዊ ያድርጉ — ጥቃቅን ለውጦች (ክብደት፣ መድኃኒቶች) እንኳን ትክክለኛ መመሪያ እንድንሰጥዎት ይረዱናል።",
    "updateNow": "አሁን አዘምን",
    "profileUpdateError": "ምርጫዎን ማዘመን አልተቻለም። እባክዎ እንደገና ይሞክሩ።",
    "healthLoopUser": "የHealthLoop ተጠቃሚ",
    "updatedLabel": "የተዘመነ",
    "noEntries": "እስካሁን ምንም መረጃ የለም።",
    "completionComplete": "መገለጫዎ ተሟልቷል። ምርጡን የጤና መመሪያ ልንሰጥዎት እንችላለን። 💚",
    "completionAlmostThere": "ጥቂት ቀርቶዎታል። ጥቂት ተጨማሪ መረጃዎች የተሻሉ መመሪያዎችን ለማግኘት ይረዳሉ።",
    "completionInProgress": "የተሻለ የጤና መመሪያ ለማግኘት መገለጫዎን ያሟሉ",
    "justNow": "አሁን",
    "minAgo": "ከ {{n}} ደቂቃ በፊት",
    "minsAgo": "ከ {{n}} ደቂቃዎች በፊት",
    "hourAgo": "ከ {{n}} ሰዓት በፊት",
    "hoursAgo": "ከ {{n}} ሰዓታት በፊት",
    "dayAgo": "ከ {{n}} ቀን በፊት",
    "daysAgo": "ከ {{n}} ቀናት በፊት",
    "checkinDueToday": "የዛሬ የጤና ምርመራ ይጠብቅዎታል",
    "checkinDueTonight": "የዛሬ ምሽት የጤና ምርመራ ይጠብቅዎታል"
  },
  "supportDeep": {
    "backToSettings": "ወደ ቅንብሮች ተመለስ",
    "quickNavAria": "የድጋፍ ክፍሎች",
    "searchPlaceholder": "እርዳታ ይፈልጉ…",
    "searchAria": "ተዘውትረው የሚጠየቁ ጥያቄዎችን ይፈልጉ",
    "resultsCount": "{{n}} ውጤት",
    "resultsCountPlural": "{{n}} ውጤቶች",
    "questionsCount": "{{n}} ጥያቄዎች",
    "liveChatTitle": "የቀጥታ ውይይት",
    "liveChatDesc": "በቀጥታ ያነጋግሩን · ከሰኞ-አርብ ከጠዋቱ 3 ሰዓት - 12 ሰዓት",
    "startChat": "ውይይት ጀምር",
    "liveChatSoonToast": "የቀጥታ ውይይት በቅርቡ ይጀምራል። እስከዚያው በኢሜይል ቢያነጋግሩን ፈጣን ምላሽ ያገኛሉ።",
    "emailUsTitle": "ኢሜይል ይላኩልን",
    "emailUsDesc": "ከ24–48 ሰዓታት ውስጥ ምላሽ እንሰጣለን",
    "copy": "ቅዳ",
    "emailCopied": "ኢሜይሉ ተገልብጧል።",
    "contactFormTitle": "የመገናኛ ቅጽ",
    "contactFormDesc": "መልእክት ይላኩልን — በኢሜይል እንመልስልዎታለን።",
    "yourNameLabel": "ስምዎ *",
    "namePlaceholder": "ሙሉ ስምዎን ያስገቡ",
    "yourEmailLabel": "ኢሜይልዎ *",
    "emailPlaceholder": "jane@example.com",
    "subjectOptional": "ርዕስ (አማራጭ)",
    "subjectPlaceholder": "በምን እንርዳዎት?",
    "messageLabel": "መልእክት *",
    "messagePlaceholder": "ስለሚፈልጉት ጉዳይ ጥቂት ይንገሩን።",
    "sending": "በመላክ ላይ…",
    "sendMessage": "መልእክት ላክ",
    "messageSent": "መልእክቱ ተልኳል",
    "messageSentDesc": "ከ24–48 ሰዓታት ውስጥ ምላሽ እንሰጣለን።",
    "callbackTitle": "ተመልሰን እንድንደውል ይጠይቁ",
    "callbackDesc": "በሚመችዎት ሰዓት ደውለን እናነጋግርዎታለን።",
    "phoneLabel": "የስልክ ቁጥር *",
    "phonePlaceholder": "+251 (9) ...",
    "preferredTimeLabel": "የሚመረጥ ሰዓት (አማራጭ)",
    "preferredTimePlaceholder": "ለምሳሌ፦ ነገ ከሰዓት",
    "reasonLabel": "ምክንያት (አማራጭ)",
    "reasonPlaceholder": "ስለ ምን መወያየት ይፈልጋሉ?",
    "submitting": "በማስገባት ላይ…",
    "requestCallback": "ጥሪ ይጠይቁ",
    "callbackRequested": "የጥሪ ጥያቄ ተልኳል",
    "callbackRequestedDesc": "በ24 ሰዓታት ውስጥ እናገኝዎታለን።",
    "medicationSupport": "የመድኃኒት ድጋፍ",
    "medicationSupportDesc": "የታዘዙ መድኃኒቶችን፣ ድጋሚ ትዕዛዞችን እና ማሳሰቢያዎችን ይከታተሉ።",
    "goToMedications": "ወደ መድኃኒቶች ይሂዱ →",
    "specialistConsultation": "የባለሙያ ምክክር",
    "specialistConsultationDesc": "ለተሻለ የጤና መመሪያ ከባለሙያ ጋር ይገናኙ።",
    "connectExpert": "ከባለሙያ ጋር ይገናኙ →",
    "videoConsult": "የቪዲዮ ምክክር",
    "videoConsultDesc": "ከባለሙያ ጋር የቪዲዮ ቆይታ ይያዙ።",
    "bookConsultation": "ምክክር ይያዙ →",
    "premium": "ልዩ (Premium)",
    "healthDisclaimer": "HealthLoop የዕለት ተዕለት የጤና ጉዞዎን ይደግፋል — የአደጋ ጊዜ ሕክምናን አይተካም። አስቸኳይ ሁኔታ ካጋጠመዎት እባክዎ በአቅራቢያዎ የሚገኝ የሕክምና ተቋም ያነጋግሩ።",
    "categoryLabel": "ዘርፍ",
    "catBug": "እንከን / ስህተት",
    "catPerformance": "ዝግተኛ አፈጻጸም",
    "catFeature": "አገልግሎቱ አይሰራም",
    "catUi": "የእይታ ችግር",
    "catOther": "ሌላ",
    "issueTitle": "የችግሩ ርዕስ *",
    "issueTitlePlaceholder": "አጭር ማጠቃለያ",
    "detailedDescription": "ዝርዝር መግለጫ *",
    "detailedDescriptionPlaceholder": "ምን ተከሰተ? ችግሩ ሲፈጠር ምን እያደረጉ ነበር? ቅደም ተከተሉን ቢገልጹልን ችግሩን ለመፍታት ይረዳናል።",
    "autoAttachNote": "የመሣሪያዎ እና የብሮውዘርዎ መረጃ በራሱ ይያያዛል።",
    "submitReport": "ሪፖርት አቅርብ",
    "reportSubmitted": "ሪፖርት ቀርቧል",
    "reportSubmittedDesc": "ቡድናችን እየሰራበት ነው።",
    "fillAllFields": "እባክዎ አስፈላጊ የሆኑ ቦታዎችን ሁሉ ይሙሉ",
    "problemReportSubmittedToast": "የችግር ሪፖርት ቀርቧል። መርምረን በቅርቡ ምላሽ እንሰጣለን።",
    "messageSentToast": "መልእክቱ ተልኳል። ከ24–48 ሰዓታት ውስጥ ምላሽ እንሰጣለን።",
    "callRequestedToast": "የጥሪ ጥያቄው ደርሶናል። በ24 ሰዓታት ውስጥ እናገኝዎታለን።",
    "submitFailGeneric": "መላክ አልተቻለም። እባክዎ እንደገና ይሞክሩ ወይም በ {{email}} ይላኩ።",
    "submitFailContact": "መላክ አልተቻለም። እባክዎ በቀጥታ በ {{email}} ይላኩ።",
    "comingSoon": "በቅርቡ የሚመጣ",
    "specialistRoadmapTitle": "ባለሙያ ያማክሩ",
    "specialistRoadmapSubtitle": "የባለሙያ ድጋፍ በቅርቡ ይጀምራል። እነዚህ አገልግሎቶች እዚህ ስለሚገኙ እርዳታ ለማግኘት ቅርብ ይሆናሉ።",
    "talkToSpecialistTitle": "ከባለሙያ ጋር ይወያዩ",
    "talkToSpecialistDesc": "ለዕለት ተዕለት የጤና ጥያቄዎችዎ ፈቃድ ካላቸው ባለሙያዎች ጋር የቀጥታ ውይይት ያድርጉ።",
    "bookSpecialistTitle": "ባለሙያ ይያዙ",
    "bookSpecialistDesc": "ከግብዎ ጋር ለሚስማማ ባለሙያ የ1 ለ 1 ቆይታ ቀጠሮ ይያዙ።",
    "liveHealthGuidanceTitle": "የቀጥታ ጤና መመሪያ",
    "liveHealthGuidanceDesc": "ስለ ስሜቶች፣ የላብራቶሪ ውጤቶች ወይም የጤና እቅዶች ፈጣን የቪዲዮ መመሪያ ያግኙ።",
    "mentalWellnessTitle": "የአእምሮ ጤና ድጋፍ",
    "mentalWellnessDesc": "ሕይወት ፈታኝ በሚሆንበት ጊዜ ከአእምሮ ጤና ባለሙያዎች ምስጢራዊ ድጋፍ ያግኙ።",
    "wellnessNavigationTitle": "የጤና ጉዞ መሪ",
    "wellnessNavigationDesc": "ትክክለኛውን ቀጣይ እርምጃ እንዲመርጡ የሚረዳዎት መመሪያ።",
    "pharmacyRoadmapTitle": "የመድኃኒት እና ፋርማሲ ድጋፍ",
    "pharmacyRoadmapSubtitle": "ከፋርማሲ ጋር የተያያዙ እርዳታዎች ሁሉ እዚህ ይገኛሉ።",
    "medicationGuidanceTitle": "የመድኃኒት መመሪያ",
    "medicationGuidanceDesc": "ስለ መድኃኒት መጠን፣ ሰዓት እና መስተጋብሮች ግልጽ መመሪያ።",
    "findNearbyPharmacyTitle": "አቅራቢያ የሚገኝ ፋርማሲ ፈልግ",
    "findNearbyPharmacyDesc": "መድኃኒት በሚያስፈልግዎ ጊዜ በአቅራቢያዎ ያሉ ታማኝ ፋርማሲዎችን በፍጥነት ያግኙ።",
    "refillReminderTitle": "የድጋሚ ትዕዛዝ ማሳሰቢያ",
    "refillReminderDesc": "አስፈላጊ መድኃኒቶች እንዳያልቁብዎ ለስላሳ ማሳሰቢያዎች።",
    "otcWellnessTitle": "ያለ ትዕዛዝ የሚወሰዱ መድኃኒቶች ምክር",
    "otcWellnessDesc": "በመረጃ ላይ የተመሰረቱ እና ደህንነታቸው የተጠበቀ ያለ ትዕዛዝ የሚወሰዱ መድኃኒቶች መመሪያ።"
  },
  "careServices": {
    "pageTitle": "የእንክብካቤ አገልግሎቶች",
    "pageSubtitle": "ለዕለት ተዕለት የጤና ጉዞዎ የተዘጋጁ የባለሙያ እና የጤና ድጋፎች።",
    "specialistCareTitle": "የባለሙያ እንክብካቤ",
    "specialistCareSubtitle": "ባለሙያዎችን ያማክሩ እና በሚፈልጉበት ጊዜ ትክክለኛውን ቀጠሮ ይያዙ።",
    "medicationPharmacyTitle": "መድኃኒት እና ፋርማሲ",
    "medicationPharmacySubtitle": "ስለ መድኃኒቶች ግልጽ መመሪያ እና የፋርማሲ እርዳታ።",
    "wellnessSupportTitle": "የጤና ድጋፍ",
    "wellnessSupportSubtitle": "የአእምሮ ጤና፣ ያለ ትዕዛዝ የሚወሰዱ መድኃኒቶች መመሪያ እና ግልጽ ቀጣይ እርምጃዎች።",
    "futureWellnessTitle": "የወደፊት የጤና አገልግሎቶች",
    "futureWellnessSubtitle": "በ HealthLoop የጤና ጉዞ ላይ በቅርቡ የሚካተቱ አገልግሎቶች።",
    "futureFeatureBadge": "የወደፊት አገልግሎት",
    "futurePersonalizedMealsTitle": "ለእርስዎ የተበጁ የምግብ እቅዶች",
    "futurePersonalizedMealsDesc": "ከግብዎ፣ ከአለርጂዎ እና ከባህልዎ ጋር የሚጣጣሙ የምግብ እቅዶች።",
    "futureHealthyDeliveryTitle": "ጤናማ ምግብ አቅርቦት",
    "futureHealthyDeliveryDesc": "ጤናማ ምግብ ከሚያዘጋጁ ኩሽናዎች እና አጋሮች ጋር የሚደረግ ትስስር።",
    "futureFarmFreshTitle": "ትኩስ የጤና ምግቦች",
    "futureFarmFreshDesc": "ከአካባቢው እርሻዎች እና ትኩስ ምርቶች አቅራቢዎች ጋር የሚደረግ ቀጥታ ትስስር።",
    "futureFoodPartnershipsTitle": "የጤና ምግብ አጋርነቶች",
    "futureFoodPartnershipsDesc": "ከጤናማ ምግብ ቤቶች፣ ግሮሰሪዎች እና የጤና ምርቶች ጋር የሚደረጉ ግንኙነቶች።",
    "futureNutritionCoachingTitle": "የአመጋገብ ስልጠና",
    "futureNutritionCoachingDesc": "እውቅና ካላቸው የአመጋገብ ባለሙያዎች የሚሰጥ የ1 ለ 1 መመሪያ።",
    "futureFamilyWellnessTitle": "የቤተሰብ ጤና እቅዶች",
    "futureFamilyWellnessDesc": "መላው ቤተሰብ በጤናማ ጎዳና ላይ እንዲቆይ የሚረዱ የጋራ እቅዶች።",
    "futureWellnessPlusTitle": "Wellness+ አባልነት",
    "futureWellnessPlusDesc": "ለበለጠ የግል መመሪያ፣ ቅድሚያ ለሚሰጠው ድጋፍ እና ጥልቅ ትንታኔዎች የሚሆን ልዩ አገልግሎት።",
    "futurePharmacyPartnersTitle": "የፋርማሲ አጋርነቶች",
    "futurePharmacyPartnersDesc": "ለልዩ መመሪያ እና ለተሻለ አገልግሎት ከታማኝ ፋርማሲዎች ጋር የሚደረግ ግንኙነት።",
    "futureAdvancedSpecialistTitle": "የላቀ የባለሙያ እንክብካቤ",
    "futureAdvancedSpecialistDesc": "የባለሙያዎች ቅንጅት፣ ሁለተኛ የሕክምና አስተያየት እና የተመቻቸ እንክብካቤ።",
    "futureWellnessMarketplaceTitle": "የጤና ግብይት",
    "futureWellnessMarketplaceDesc": "የተመረጡ የጤና ምርቶች እና አገልግሎቶች የሚገኙበት መድረክ።",
    "futureVendorCollabTitle": "የአቅራቢዎች ትብብር ሥርዓት",
    "futureVendorCollabDesc": "ለጤናማ ምግብ እና ለጤና አጋሮች ጥራትን የማረጋገጫ ሥርዓት።"
  },
  "dashboardDeep": {
    "healthProfile": "የጤና መገለጫ",
    "notifications": "ማሳሰቢያዎች",
    "familyAccounts": "የቤተሰብ መለያዎች",
    "settings": "ቅንብሮች",
    "logout": "ውጣ",
    "allCaughtUp": "ሁሉንም ተግባራት አከናውነዋል።",
    "weekInReview": "የሳምንቱ ማጠቃለያ",
    "dismissNotification": "ማሳሰቢያውን አጥፋ",
    "dismissWeeklyDigest": "ሳምንታዊ ማጠቃለያውን አጥፋ",
    "notificationsAria": "ማሳሰቢያዎች",
    "profileMenuAria": "የመገለጫ ዝርዝር ክፈት",
    "loadingWellness": "የጤና ማጠቃለያዎን በማዘጋጀት ላይ",
    "nextTip": "ቀጣይ ምክር",
    "todayAtGlance": "ዛሬ በጨረፍታ",
    "healthScoreLabel": "የጤና ነጥብ",
    "currentStreakLabel": "የቀናት ሰንሰለት",
    "todaysProgress": "የዛሬ ግስጋሴ",
    "insightForYou": "ለእርስዎ የሚሆን መረጃ",
    "checkMyHealthRisk": "የጤና ስጋቴን ልመርምር",
    "quickAccess": "ፈጣን መግቢያ",
    "exploreCareServicesTitle": "አገልግሎቶችን ያስሱ",
    "exploreCareServicesSubtitle": "የባለሙያ እንክብካቤ · ፋርማሲ · ጤና — ሁሉንም በአንድ ቦታ።",
    "familyCare": "የቤተሰብ እንክብካቤ",
    "healthLibrary": "የጤና መጽሐፍት",
    "myHealthData": "የጤና መረጃዬ",
    "askQuestion": "ጥያቄ ጠይቅ",
    "dashLoadError": "መረጃውን መጫን አልተቻለም። እባክዎ እንደገና ይሞክሩ።",
    "taskUpdateError": "ተግባሩን ማዘመን አልተቻለም። እባክዎ እንደገና ይሞክሩ።",
    "perfectDay": "ድንቅ ቀን! 🎉 ሰንሰለቱ ቀጥሏል።",
    "letsStart": "እንጀምር",
    "yourNextStepToday": "የዛሬ ቀጣይ እርምጃዎ",
    "completeDailyCheck": "የዕለት ተዕለት የጤና ምርመራዎን ያጠናቅቁ",
    "startDailyCheck": "ምርመራ ጀምር",
    "viewAll": "ሁሉንም ተመልከት",
    "graceProtected": "ጥበቃ ተደርጎለታል",
    "todaysHealthRecommendations": "የዛሬ የጤና ምክሮች",
    "updateViaCheck": "በዕለታዊ ምርመራ ያዘምኑ",
    "healthInsight": "የጤና ግንዛቤ",
    "riskCheckSubtext": "በጥቂት ሰከንዶች ውስጥ የግል የጤና መረጃ ያግኙ",
    "foodDiet": "ምግብ እና አመጋገብ",
    "healthScoreNew": "የጤና ነጥብ · አዲስ",
    "letsBuildScore": "የጤና ነጥብዎን አብረን እንገንባ",
    "oneHealthyHabitAtATime": "አንድ ጤናማ ልማድ በአንድ ጊዜ።",
    "nextCheck": "ቀጣይ ምርመራ፦",
    "todayAt8pm": "ዛሬ ምሽት 2:00 ሰዓት ላይ",
    "wellnessTipForYou": "የዛሬ የጤና ምክር · ለእርስዎ",
    "wellnessTipForFactor": "የዛሬ የጤና ምክር · ለ {{factor}}",
    "logged": "ተመዝግቧል",
    "gotIt": "ተረድቻለሁ 👍",
    "gladToSeeYou": "ዛሬ ስለመጡ ደስ ብሎናል 💚",
    "takesLessThan60Sec": "ከ60 ሰከንድ በታች ይፈጃል",
    "scoreReadyWhenYou": "ሲዘጋጁ እንጀምራለን",
    "scoreCompleteFirstCheck": "የግል የጤና መመሪያ ለማግኘት የመጀመሪያውን ምርመራ ያጠናቅቁ።",
    "scoreExcellent": "በጣም ጥሩ",
    "scoreSupportExcellent": "ዛሬ በጥሩ የጤና ሁኔታ ላይ ነዎት። ይቀጥሉበት።",
    "scoreGood": "ጥሩ",
    "scoreSupportGood": "ጥሩ እየሰሩ ነው። ጤናማ ልማዶችዎን ይቀጥሉ።",
    "scoreModerate": "መካከለኛ",
    "scoreSupportModerate": "ደህና ነዎት፣ ነገር ግን አንዳንድ ነገሮች ትኩረት ያስፈልጋቸዋል።",
    "scoreNeedsAttention": "ትኩረት ያስፈልገዋል",
    "scoreSupportNeedsAttention": "ዛሬ ጤናዎ ትኩረት ይፈልጋል። ጥቃቅን ለውጦች ሊረዱዎት ይችላሉ።"
  },
  "emailVerify": {
    "bannerWithEmail": "መለያዎ ደህንነቱ የተጠበቀ እንዲሆን እና ዕለታዊ ማሳሰቢያዎች እንዲደርሱዎት እባክዎ ኢሜይልዎን ({{email}}) ያረጋግጡ።",
    "bannerNoEmail": "መለያዎ ደህንነቱ የተጠበቀ እንዲሆን እና ዕለታዊ ማሳሰቢያዎች እንዲደርሱዎት እባክዎ ኢሜይልዎን ያረጋግጡ።",
    "sending": "በመላክ ላይ…",
    "resend": "ኢሜይሉን ድጋሚ ላክ",
    "sentToast": "የማረጋገጫ ኢሜይል ተልኳል። እባክዎ ኢሜይልዎን ይመልከቱ።",
    "sendFailToast": "የማረጋገጫ ኢሜይሉን መላክ አልተቻለም። ቆይተው ይሞክሩ።"
  },
  "forgotPassword": {
    "title": "የይለፍ ቃል ረሱ?",
    "subtitle": "አይጨነቁ! ኢሜይልዎን ያስገቡ እና የይለፍ ቃል መቀየሪያ መመሪያ እንልክልዎታለን።",
    "emailLabel": "የኢሜይል አድራሻ",
    "emailPlaceholder": "your.email@example.com",
    "sendResetLink": "የመቀየሪያ ሊንክ ላክ",
    "sending": "በመላክ ላይ…",
    "backToLogin": "ወደ መግቢያ ተመለስ",
    "resendLink": "ኢሜይሉን ድጋሚ ላክ",
    "successTitle": "ኢሜይልዎን ይመልከቱ",
    "successBody": "በዚህ ኢሜይል ({{email}}) መለያ ካለዎት፣ የይለፍ ቃል መቀየሪያ ሊንክ ልከናል::",
    "linkExpires": "ሊንኩ በ30 ደቂቃ ውስጥ አገልግሎት ያቆማል።",
    "successToast": "መመሪያውን ለማግኘት ኢሜይልዎን ይመልከቱ",
    "errEmptyEmail": "እባክዎ የኢሜይል አድራሻዎን ያስገቡ",
    "errInvalidEmail": "እባክዎ ትክክለኛ የኢሜይል አድራሻ ያስገቡ",
    "errNetwork": "ከኢንተርኔት ጋር መገናኘት አልተቻለም። ግንኙነትዎን አረጋግጠው እንደገና ይሞክሩ።",
    "errGeneric": "ኢሜይሉን መላክ አልተቻለም። እባክዎ እንደገና ይሞክሩ ወይም ድጋፍ ሰጪዎችን ያነጋግሩ።"
  },
  "resetPassword": {
    "title": "አዲስ የይለፍ ቃል ያውጡ",
    "subtitle": "ለእርስዎ መለያ ጠንካራ የይለፍ ቃል ይፍጠሩ",
    "newPasswordLabel": "አዲስ የይለፍ ቃል",
    "newPasswordPlaceholder": "አዲስ የይለፍ ቃል ያስገቡ",
    "confirmPasswordLabel": "የይለፍ ቃሉን ያረጋግጡ",
    "confirmPasswordPlaceholder": "አዲሱን የይለፍ ቃል ደግመው ያስገቡ",
    "requirementsHint": "ቢያንስ 8 ፊደላት ሆኖ ትልቅ እና ትንሽ ፊደላትን እንዲሁም ቁጥር መያዝ አለበት",
    "resetPassword": "የይለፍ ቃል ቀይር",
    "resetting": "በመቀየር ላይ…",
    "successTitle": "የይለፍ ቃል በተሳካ ሁኔታ ተቀይሯል!",
    "successBody": "አሁን በአዲሱ የይለፍ ቃልዎ መግባት ይችላሉ።",
    "successToast": "የይለፍ ቃል በተሳካ ሁኔታ ተቀይሯል!",
    "goToLogin": "ወደ መግቢያ ይሂዱ",
    "invalidLinkTitle": "የማይሰራ ሊንክ",
    "invalidLinkBody": "ይህ የይለፍ ቃል መቀየሪያ ሊንክ አይሰራም ወይም ጊዜው አልፎበታል።",
    "requestNewLink": "አዲስ ሊንክ ይጠይቁ",
    "showPassword": "የይለፍ ቃል አሳይ",
    "hidePassword": "የይለፍ ቃል ደብቅ",
    "errInvalidLink": "የማይሰራ ሊንክ",
    "errMismatch": "የይለፍ ቃላቱ አይዛመዱም",
    "errTooShort": "የይለፍ ቃሉ ቢያንስ 8 ፊደላት መሆን አለበት",
    "errExpiredToken": "ይህ ሊንክ ጊዜው አልፎበታል ወይም አይሰራም። እባክዎ አዲስ ይጠይቁ።",
    "errNetwork": "ከኢንተርኔት ጋር መገናኘት አልተቻለም። ግንኙነትዎን አረጋግጠው እንደገና ይሞክሩ።",
    "errGeneric": "የይለፍ ቃል መቀየር አልተቻለም። እባክዎ እንደገና ይሞክሩ።"
  },
  "tips": {
    "water1": "ከእንቅልፍ እንደተነሱ በ30 ደቂቃ ውስጥ ውሃ መጠጣት የሰውነትዎን የውሃ መጠን እና የንቃት ስሜት ይጨምራል።",
    "water2": "ከእያንዳንዱ ምግብ በፊት አንድ ብርጭቆ ውሃ መጠጣት ጥማትን ለመከላከል ቀላሉ መንገድ ነው።",
    "water3": "በውሃዎ ውስጥ የሎሚ ቁራጭ ወይም ጥቂት የናና ቅጠል መጨመር የውሃ መጠጣቱን አስደሳች ያደርገዋል።",
    "meals1": "በቀን አንድ ተጨማሪ የአትክልት ምግብ መጨመር ለጨጓራና ለልብ ጤና ይረዳል።",
    "meals2": "ከቁርስ ጋር ጥቂት ለውዝ ወይም የጥራጥሬ ዘሮችን መመገብ ቀኑን ሙሉ ንቁ ሆነው እንዲቆዩ ይረዳል።",
    "meals3": "ከጭማቂ ይልቅ ፍራፍሬን መመገብ ይመረጣል — በውስጡ ያለው ፋይበር የደም ስኳርዎን ያመጣጥናል።",
    "steps1": "ከምግብ በኋላ ለ10 ደቂቃ በእግር መጓዝ ሰውነትዎ ስኳርን በቀላሉ እንዲያብላላ ይረዳዋል።",
    "steps2": "ጠዋት ለ5 ደቂቃ ሰውነትን ማሳሳብ ውጥረትን ይቀንሳል፣ ቀኑንም በሰላም እንዲጀምሩ ይረዳል።",
    "steps3": "በቀን አንድ ጊዜ እንኳን በደረጃ መውጣት በሂደት የልብ ጥንካሬን ይገነባል።",
    "sleep1": "ከመተኛትዎ አንድ ሰዓት በፊት መብራቶችን ማደብዘዝ ለጥልቅ እንቅልፍ ይረዳል።",
    "sleep2": "ዘወትር በተመሳሳይ ሰዓት መነሳት — በሳምንቱ መጨረሻም ቢሆን — የእንቅልፍ ዑደትዎን ያመጣጥናል።",
    "sleep3": "ጠዋት ለ10 ደቂቃ የፀሐይ ብርሃን ማግኘት የእንቅልፍ ስርዓትዎ በተፈጥሮ እንዲስተካከል ይረዳል።",
    "general1": "ለሁለት ደቂቃ በቀስታ መተንፈስ ጭንቀትን ይቀንሳል፣ ትኩረትዎንም ያስተካክላል።",
    "general2": "ዛሬ ያከናወኑትን አንድ መልካም ነገር ያስቡ — ትናንሽ የአእምሮ ድሎች ለትልቅ ስኬት መሰረት ናቸው።",
    "general3": "ዛሬ ይህን በማድረግዎ ለራስዎ ትልቅ ስጦታ ሰጥተዋል። ይህ ልምድ ሌሎች ነገሮችንም ቀላል ያደርግልዎታል።"
  },
  "factors": {
    "hydration": "የውሃ መጠን",
    "nutrition": "አመጋገብ",
    "movement": "እንቅስቃሴ",
    "sleep": "እንቅልፍ"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "የምግብ አማራጮችን መጫን አልተቻለም",
    "prefsSaved": "የምግብ ምርጫዎችዎ ተቀምጠዋል! የምግብ ዝርዝሩ እየታደሰ ነው...",
    "prefsSaveFail": "ምርጫዎችን ማስቀመጥ አልተቻለም",
    "newOptionsFail": "አዳዲስ አማራጮችን መጫን አልተቻለም",
    "invalidZip": "እባክዎ ትክክለኛ ባለ 5 አሃዝ ዚፕ ኮድ ያስገቡ",
    "noVendorsArea": "በዚህ አካባቢ እስካሁን ምንም አቅራቢዎች የሉም። አገልግሎታችንን እያሰፋን ነው!",
    "vendorsFetchFail": "አቅራቢዎችን ማግኘት አልተቻለም",
    "selectVendorFirst": "እባክዎ መጀመሪያ የሚያደርስልዎትን አቅራቢ ይምረጡ",
    "removedFromCart": "ከቅርጫት ተወግዷል",
    "orderPlaced": "ትዕዛዝዎ በተሳካ ሁኔታ ተጠናቋል! 🎉",
    "enterZipFirst": "እባክዎ መጀመሪያ በማድረሻው ክፍል ውስጥ ዚፕ ኮድዎን ያስገቡ",
    "mealNotAvailable": "ይህ ምግብ በአሁኑ ጊዜ በአካባቢዎ አይገኝም",
    "mealUnavailable": "ይህ ምግብ በአቅራቢያዎ ባሉ አቅራቢዎች ዘንድ አይገኝም",
    "vendorOptionsFail": "የአቅራቢ አማራጮችን መጫን አልተቻለም",
    "favoriteSaveFail": "በተወዳጅነት ማስቀመጥ አልተቻለም",
    "removedFromFavorites": "ከተወዳጆች ዝርዝር ተወግዷል",
    "favoriteRemoveFail": "ከተወዳጆች ዝርዝር ማስወገድ አልተቻለም",
    "cartEmpty": "ቅርጫትዎ ባዶ ነው",
    "noMealOptions": "ምንም የምግብ አማራጮች የሉም",
    "loadingOptions": "የምግብ አማራጮች በመጫን ላይ...",
    "selectPreferences": "የምግብ ምርጫዎችዎን ይምረጡ",
    "mealBuilder": "ምግብ አዘጋጅ",
    "myFavorites": "የእኔ ተወዳጆች",
    "myFavoriteMeals": "የእኔ ተወዳጅ ምግቦች",
    "noFavoritesYet": "እስካሁን ምንም ተወዳጅ ምግብ የለም!",
    "price": "ዋጋ",
    "delivery": "ማድረሻ",
    "deliveryFee": "የማድረሻ ክፍያ",
    "distance": "ርቀት",
    "subtotal": "የምርቶቹ ዋጋ",
    "total": "ጠቅላላ",
    "orderNumber": "የትዕዛዝ ቁጥር",
    "vendor": "አቅራቢ",
    "totalAmount": "ጠቅላላ ክፍያ",
    "estimatedDelivery": "የሚደርስበት ግምታዊ ጊዜ",
    "whyThisMeal": "ይህ ምግብ ለምን ተመረጠ?",
    "selectThisMeal": "ይህንን ምግብ ይምረጡ",
    "swapMeal": "ምግብ ይቀይሩ",
    "orderThisMeal": "ይህንን ምግብ ይዘዙ",
    "notAvailableNearYou": "በአቅራቢያዎ አይገኝም",
    "tryAdjustingPrefs": "የምግብ ጥቆማዎችን ለማየት የምግብ ምርጫዎችዎን ለማስተካከል ይሞክሩ",
    "myMealPlanSummary": "የምግብ ዕቅዴ ማጠቃለያ",
    "saveCompletePlan": "ሙሉ ዕቅዱን አስቀምጥ",
    "yourFoodPreferences": "የእርስዎ የምግብ ምርጫዎች",
    "editPreferences": "ምርጫዎችን ያስተካክሉ",
    "healthyMealDelivery": "ጤናማ ምግብ ማድረሻ",
    "enableDelivery": "ማድረሻን ፍቀድ",
    "enterZipCode": "የሚገኙ ምግቦችን ለማየት የፖስታ ቁጥርዎን ወይም ዚፕ ኮድዎን ያስገቡ",
    "enterPostcode": "የፖስታ ቁጥር / ዚፕ ኮድ ያስገቡ",
    "postcodePlaceholder": "ምሳሌ፦ 10001",
    "postcodePartialHint": "ትክክለኛ የአካባቢ ውጤቶችን ለማግኘት እባክዎ ሙሉ የፖስታ ቁጥርዎን ያስገቡ።",
    "noLocalPartnersFallback": "እስካሁን ምንም የአካባቢው አጋሮች አልተገኙም። በምትኩ ባህላዊ ይዘት ያላቸውን የምግብ ግብዓቶች ጥቆማ እያሳየን ነው።",
    "noLivePartnersFallback": "በአሁኑ ጊዜ በአካባቢዎ የሚሰሩ የHealthLoop የምግብ አጋሮች የሉም።",
    "culturalNutritionTitle": "ጤናማ የአካባቢ ምርቶች",
    "culturalNutritionSubtitle": "ለእርስዎ የተዘጋጀ የጤናማ አኗኗር መመሪያ — ከባህልዎ ጋር የሚስማማ እና ለአካባቢዎ የሚሆን መረጃ።",
    "viewIngredientGuidance": "መመሪያውን ይመልከቱ",
    "popularWellnessTitle": "በአቅራቢያዎ ያሉ ተወዳጅ ጤናማ ምግቦች",
    "popularWellnessIntro": "ከባህልዎ ጋር የሚስማሙ ግብዓቶች እና በአካባቢዎ ያሉ ሰዎች አዘውትረው የሚጠቀሟቸው ጤናማ ምግቦች።",
    "subsectionPopularFoodsTitle": "የእለት ተእለት ጤናማ ምግቦች",
    "subsectionCulturalIngredientsTitle": "ባህላዊ የምግብ ግብዓት ጥቆማዎች",
    "subsectionHealthySwapsTitle": "ጤናማ የምግብ ቅያሬ ሀሳቦች",
    "subsectionLocalEnvironmentTitle": "የአካባቢው የጤና ሁኔታ",
    "subsectionLocalEnvironmentIntro": "በአካባቢዎ ያሉ ሰዎች ባህላዊና ጤናማ አማራጮችን የሚያገኙባቸው ቦታዎች።",
    "findLocalTitle": "የአካባቢ ጤናማ አማራጮች",
    "findLocalSubtitle": "በአቅራቢያዎ ያሉ ጤናማ አቅራቢዎችን፣ ሱቆችን እና ባህላዊ ግብዓቶችን ያግኙ።",
    "findOptions": "አማራጮችን ፈልግ",
    "searching": "በመፈለግ ላይ…",
    "nearbyVendorsFound": "{{count}} በአቅራቢያዎ ያሉ ጤናማ አማራጮች ተገኝተዋል",
    "orderHintEnabled": "የአቅራቢዎችን ዋጋ ለማየት ከታች ካሉት የምግብ ካርዶች በአንዱ ላይ \"ይህንን ምግብ ይዘዙ\" የሚለውን ይጫኑ።",
    "orderHintDisabled": "በእነዚህ የምግብ ካርዶች አማካኝነት በቀጥታ ለማዘዝ ከላይ ያለውን \"ማድረሻን ፍቀድ\" የሚለውን ያብሩ።",
    "localIngredientTitle": "የአካባቢ ግብዓቶች መገኘት",
    "localIngredientIntro": "ባህላዊ የሆኑ መሰረታዊ ምግቦች እና የት ሊገኙ እንደሚችሉ።",
    "lookFor": "ይህንን ይፈልጉ",
    "noVendorsFallback": "እስካሁን የተረጋገጡ የምግብ አቅራቢዎች እዚህ የሉም — ይሁን እንጂ ከላይ ያለው የግብዓት መመሪያ በማንኛውም የአካባቢ መደብር ወይም ገበያ ውስጥ ይሰራል።",
    "showingMealsFrom": "የምግብ ዝርዝር ምንጭ፦",
    "sectionSnapshot": "የእለቱ የአመጋገብ እይታ",
    "sectionSnapshotSubtitle": "የዛሬው የውሃ አወሳሰድ፣ ካሎሪ እና የምግብ ሚዛን አጭር መረጃ።",
    "snapshotHydration": "ውሃ አወሳሰድ",
    "snapshotHydrationHint": "ዛሬ ከ6-8 ብርጭቆ ለመጠጣት ይሞክሩ።",
    "snapshotCalories": "ካሎሪ",
    "snapshotCaloriesHint": "ክትትል በቅርቡ ይጀምራል።",
    "snapshotBalance": "የምግብ ሚዛን",
    "mealsLogged": "ምግቦች ተመርጠዋል",
    "snapshotTip": "የጤና ምክር",
    "snapshotTipHint": "በቀጣይ ምግብዎ ላይ አንድ ተጨማሪ አትክልት ይጨምሩ።",
    "sectionRecommendations": "ብልህ ጥቆማዎች",
    "sectionRecommendationsSubtitle": "ባህላዊ የምግብ ግብዓት መመሪያዎች እና ጤናማ የቅያሬ ሀሳቦች።",
    "sectionGoals": "የአመጋገብ ግቦች",
    "sectionGoalsSubtitle": "ለእርስዎ አስፈላጊ የሆኑ ውጤቶችን ይከታተሉ።",
    "goalWeight": "ክብደትን መቆጣጠር",
    "goalWeightDesc": "ተገቢ ክብደትን ለመጠበቅ የተመጣጠኑ ምግቦች።",
    "goalEnergy": "ለጉልበትና ብርታት",
    "goalEnergyDesc": "ለረጅም የስራ ቀናት የሚሆን ቋሚ ጉልበት።",
    "goalImmunity": "የሰውነት መከላከያን ማጠናከር",
    "goalImmunityDesc": "ጤናዎን ለመጠበቅ በፀረ-ኦክሳይደንት የበለጸጉ ምርጫዎች።",
    "goalFamily": "የቤተሰብ አመጋገብ",
    "goalFamilyDesc": "ለልጆች እና ለእናቶች የሚሆኑ አማራጮችን ያካተተ።",
    "sectionGuidance": "የምግብ መመሪያ",
    "sectionGuidanceSubtitle": "እንደ ምርጫዎ ሊቀያየሩ የሚችሉ ቁርስ፣ ምሳ፣ እራት እና መክሰስ ሀሳቦች።",
    "futureNutritionTitle": "የወደፊት የአመጋገብ ድጋፍ",
    "futureNutritionBody": "ለእርስዎ የተዘጋጀ የአመጋገብ መመሪያ፣ የጤናማ ምግብ አጋርነት እና ለቤተሰብ የሚያተኩር የምግብ ድጋፍ በቅርቡ በHealthLoop ይካተታሉ።",
    "comingSoon": "በቅርቡ ይጠብቁ",
    "coverageLocalStores": "የአካባቢ ጤናማ ሱቆች",
    "coverageLocalFarms": "የአካባቢ እርሻዎች",
    "coverageCertifiedVendors": "የተረጋገጡ አቅራቢዎች",
    "coverageFreshProduce": "ትኩስ ምርቶች",
    "medWellnessFutureTitle": "የመድኃኒት እና የጤና ድጋፍ",
    "medWellnessFutureDesc": "የአመጋገብ ዕቅድዎን ከመድኃኒት አጠቃቀም ጋር በተገናኘ መመሪያ ያጣምራል። ሙሉ አገልግሎቱን በ'እርዳታና ድጋፍ' ስር ያገኙታል።",
    "pharmacyAssistFutureTitle": "የፋርማሲ ድጋፍ",
    "pharmacyAssistFutureDesc": "በአቅራቢያዎ ያሉ ፋርማሲዎችን እና የመድኃኒት ማስታወሻዎችን ከምግብዎ ጎን ለጎን ያግኙ። ሙሉ አገልግሎቱን በ'እርዳታና ድጋፍ' ስር ያገኙታል።",
    "savePreferences": "ምርጫዎችን አስቀምጥ",
    "quickAccessSavedMeals": "የተቀመጡ ምግቦችዎ ፈጣን መዳረሻ",
    "saveMealsFromBuilder": "ከምግብ አዘጋጁ ክፍል ምግቦችን ያስቀምጡ",
    "chooseVendor": "ይህንን ምግብ ለማዘዝ አቅራቢ ይምረጡ",
    "yourCart": "ቅርጫትዎ",
    "addMealsToStart": "ለመጀመር ከታች ካሉት አማራጮች ምግብ ይጨምሩ",
    "orderPlacedDesc": "የጤናማ ምግብ ትዕዛዝዎ በተሳካ ሁኔታ ተቀምጧል",
    "continueShopping": "መግዛቱን ቀጥል",
    "trackOrder": "ትዕዛዝዎን ይከታተሉ",
    "healthyStoresTitle": "በአቅራቢያዎ ያሉ ጤናማ መሸጫዎች እና የጤንነት ገበያዎች",
    "healthyStoresIntro": "ለግዢ ሀሳብ እንዲሆኑ በአካባቢዎ ሊፈልጓቸው የሚገቡ የጤናማ ምርቶች መሸጫዎች (ለማድረስ የታሰቡ አይደሉም)።",
    "healthyStoresGuidanceTitle": "የጤናማ ግብይት መመሪያ",
    "healthyStoresDisclaimer": "HealthLoop አጠቃላይ የጤንነት እና የጤናማ ግብይት መነሳሻዎችን ብቻ ያጋራል — ይህ የሕክምና ወይም የአመጋገብ ምክር አይደለም።",
    "healthyStores": {
      "organic": {
        "type": "ኦርጋኒክ ግሮሰሪዎች",
        "description": "ትኩስ፣ ኬሚካል ያልተረጨባቸው ምርቶች እና በፋብሪካ ብዙ ያልተቀነባበሩ ምግቦች።",
        "tags": [
          "ተፈጥሯዊ-ምግቦች",
          "ትኩስ ምርቶች"
        ]
      },
      "farmers": {
        "type": "የገበሬዎች ገበያ",
        "description": "በአካባቢው የበቀሉ ወቅታዊ ፍራፍሬዎች፣ አትክልቶች እና ባህላዊ ምርቶች በቀጥታ ከአምራቾች።",
        "tags": [
          "አካባቢያዊ",
          "ወቅታዊ"
        ]
      },
      "african": {
        "type": "የአፍሪካ ትኩስ ምርቶች መሸጫ",
        "description": "ቦይ፣ ፕላንቴን፣ አረንጓዴ ቅጠላቅጠሎች እና የምዕራብ/ምስራቅ አፍሪካ መሰረታዊ ምግቦች።",
        "tags": [
          "ባህላዊ",
          "ትኩስ ምርቶች"
        ]
      },
      "caribbean": {
        "type": "የካሪቢያን ተፈጥሯዊ ምግቦች",
        "description": "ካላሉ፣ ካሳቫ፣ ስኮች ቦኔት፣ አኪ፣ ዳቦ ፍሬ እና የደሴቱ መሰረታዊ ምግቦች።",
        "tags": [
          "ባህላዊ",
          "ተፈጥሯዊ-ምግቦች"
        ]
      },
      "asian": {
        "type": "የእስያ አትክልት ሱፐርማርኬቶች",
        "description": "ቦክ ቾይ፣ ዳይኮን፣ የሎተስ ስር፣ ቶፉ፣ ትኩስ ቅመማ ቅመሞች እና የእስያ ምግቦች።",
        "tags": [
          "ባህላዊ",
          "ትኩስ ምርቶች"
        ]
      },
      "halal": {
        "type": "የሀላል ጤናማ ምግብ ገበያዎች",
        "description": "ሀላል የሆኑ ስጋዎች፣ ትኩስ ምርቶች እና ባህላዊ ቅመሞች።",
        "tags": [
          "ሀላል",
          "ባህላዊ"
        ]
      },
      "mediterranean": {
        "type": "የሜዲትራኒያን ተፈጥሯዊ ምግቦች",
        "description": "የወይራ ዘይት፣ ጥራጥሬዎች፣ ትኩስ ቅመሞች፣ ጥሬ እህሎች እና የሜዲትራኒያን ምግቦች።",
        "tags": [
          "ባህላዊ",
          "ተፈጥሯዊ-ምግቦች"
        ]
      },
      "wellness": {
        "type": "ለጤንነት ትኩረት የሚሰጡ ሱቆች",
        "description": "የተመረጡ ተፈጥሯዊ ምግቦች፣ ከዕፅዋት የተቀመሙ አማራጮች እና ንጹህ ይዘት ያላቸው ምርቶች።",
        "tags": [
          "ተፈጥሯዊ-ምግቦች",
          "ከዕፅዋት-የተሰሩ"
        ]
      }
    },
    "healthyShoppingTips": [
      "መጀመሪያ በሱቁ ዳርቻዎች ይገበዩ — ትኩስ ምርቶች እና የወተት ተዋጽኦ አማራጮች ብዙውን ጊዜ በዳርቻ በኩል ይገኛሉ።",
      "በፋብሪካ የተቀነባበሩ ምግቦች ይልቅ ሙሉ እና ተፈጥሯዊ ምግቦችን ያስቀድሙ።",
      "የአካባቢውን ወቅታዊ ምርቶች ይምረጡ — ብዙውን ጊዜ ትኩስ፣ ርካሽ እና አልሚ ንጥረ ነገር ያላቸው ናቸው።",
      "ስለ ምርቱ አመጣጥ እና አያያዝ ሻጮችን ይጠይቁ — ብዙዎቹ በደስታ ይነግሩዎታል።"
    ]
  },
  "messages": {
    "success": "ተሳክቷል!",
    "error": "ስህተት",
    "saved": "በተሳካ ሁኔታ ተቀምጧል",
    "updated": "በተሳካ ሁኔታ ታድሷል",
    "deleted": "በተሳካ ሁኔታ ተሰርዟል",
    "confirmDelete": "ይህንን በእርግጠኝነት መሰረዝ ይፈልጋሉ?",
    "networkError": "የኔትወርክ ችግር። እባክዎ እንደገና ይሞክሩ።",
    "somethingWrong": "ችግር ተፈጥሯል",
    "failedToLoad": "ዳሽቦርዱን መጫን አልተቻለም",
    "offlineMode": "ከኢንተርኔት ውጭ - የተወሰኑ መረጃዎች ብቻ ይታያሉ",
    "locationDenied": "የአካባቢ መረጃ የማግኘት ፍቃድ ተከልክሏል። ለማስተካከል የብሮውዘርዎን ቅንብር ይመልከቱ።",
    "locationUnavailable": "የአካባቢ መረጃ ማግኘት አልተቻለም",
    "locationTimeout": "የአካባቢ መረጃ ጥያቄው ጊዜ አልፎበታል። እባክዎ እንደገና ይሞክሩ።",
    "locationError": "አካባቢዎን ማወቅ አልተቻለም",
    "locationGranted": "የአካባቢ መረጃ ተፈቅዷል! በአቅራቢያዎ ያሉ አማራጮችን እያሳየን ነው",
    "locationNotSupported": "ብሮውዘርዎ የአካባቢ መረጃ አገልግሎትን አይደግፍም",
    "requestingLocation": "የአካባቢ መረጃ ለመጠቀም በመጠየቅ ላይ..."
  },
  "trust": {
    "medicalDisclaimer": "የህክምና ማስጠንቀቂያ",
    "privacySecure": "መረጃዎ የግልና ደህንነቱ የተጠበቀ ነው",
    "dataEncrypted": "ሁሉም መረጃዎች በምስጢር የተጠበቁ ናቸው",
    "notMedicalAdvice": "የህክምና ምክር አይደለም",
    "consultProvider": "ሁልጊዜ የጤና ባለሙያዎን ያማክሩ",
    "evidenceBased": "በመረጃ የተደገፈ መመሪያ",
    "generalEducation": "አጠቃላይ የጤና ትምህርት",
    "preventiveGuidance": "የመከላከያ መመሪያ",
    "lifestyleSupport": "ለግንዛቤ እና ለአኗኗር ድጋፍ",
    "lastUpdated": "ለመጨረሻ ጊዜ የታደሰው",
    "expertReviewed": "በባለሙያ የተገመገመ",
    "aiGenerated": "በሰው ሰራሽ አስተውሎት (AI) የተዘጋጀ መረጃ",
    "disclaimerShort": "HealthLoop የጤና ትምህርት ይሰጣል እንጂ የባለሙያ ህክምና ምክርን አይተካም።",
    "disclaimerFull": "HealthLoop የመከላከያ ጤናን እና ቅድመ ግንዛቤን ይደግፋል። የጤና ትምህርት፣ የልማድ ክትትል እና የጤና መረጃዎችን እንሰጣለን። ይህም ፈቃድ ያለው የህክምና አገልግሎትን አይተካም። ለህክምና ምክር፣ ለምርመራ ወይም ለህክምና ሁልጊዜ ብቁ የጤና ባለሙያዎችን ያማክሩ።",
    "trustBanner": {
      "title": "HealthLoop የእርስዎን የጤና ጉዞ ለመደገፍ እዚህ አለ",
      "description": "ከታመኑ ምንጮች የተገኙ አጠቃላይ የጤና ትምህርቶችን እና የመከላከያ መመሪያዎችን እንሰጣለን። ይህ የባለሙያ ህክምና ምክርን አይተካም። ለህክምና ውሳኔዎች ሁልጊዜ ብቁ የጤና ባለሙያዎችን ያማክሩ።"
    }
  },
  "health": {
    "preventiveHealth": "የመከላከያ ጤና ክትትል",
    "educationHub": "የትምህርት ማዕከል",
    "engagementWidget": "ተሳትፎ መከታተያ",
    "wellnessCheckIn": "የጤና ሁኔታ ምርመራ",
    "todaysMetrics": "የዛሬ መለኪያዎች",
    "bloodPressure": "የደም ግፊት",
    "heartRate": "የልብ ምት",
    "weight": "ክብደት",
    "sleep": "እንቅልፍ",
    "waterIntake": "የውሃ አወሳሰድ",
    "exercise": "የአካል ብቃት እንቅስቃሴ",
    "logMetric": "መለኪያ ይመዝግቡ",
    "viewHistory": "ታሪክ ይመልከቱ"
  },
  "aiInsights": {
    "title": "የAI ጤና መረጃዎች",
    "comingSoon": "መረጃዎችዎ በመሰብሰብ ላይ ናቸው",
    "comingSoonDesc": "ለአንድ ወይም ለሁለት ቀናት የእለት ተእለት ምርመራዎን ሲያጠናቅቁ፣ ለእርስዎ የተዘጋጁ ለስላሳ መረጃዎችን እዚህ እናሳያለን።",
    "learnMore": "ተጨማሪ ይወቁ",
    "evidenceSources": {
      "WHO": "በዓለም የጤና ድርጅት (WHO) መመሪያዎች ላይ የተመሰረተ",
      "NHS": "ከNHS ምክረ-ሀሳቦች ጋር የተጣጣመ",
      "CDC": "በCDC መመሪያዎች የተደገፈ",
      "RESEARCH": "በባለሙያዎች በተገመገሙ ጥናቶች ላይ የተመሰረተ",
      "CLINICAL": "በክሊኒካዊ ጥናቶች የተደገፈ"
    }
  },
  "dailyInsight": {
    "title": "የእለት የጤና መረጃ",
    "gettingStarted": "መጀመር",
    "focus": "ትኩረት",
    "quickInsight": "ፈጣን መረጃ",
    "simpleExplanation": "ቀላል ማብራሪያ",
    "realLifeImpact": "በዕለት ተዕለት ሕይወት ላይ ያለው ተጽእኖ",
    "yourActionStep": "የእርስዎ ቀጣይ እርምጃ",
    "basedOnYour": "በእርስዎ... ላይ የተመሰረተ",
    "personalizedFor": "በቅርብ ጊዜ የጤና መረጃዎ ላይ በመመስረት ለእርስዎ የተዘጋጀ",
    "getNewInsight": "አዲስ መረጃ አግኝ",
    "newInsightLoaded": "አዲስ መረጃ ተጭኗል! 💡",
    "failedToRefresh": "መረጃውን ማደስ አልተቻለም",
    "priority": {
      "high": "እዚህ ላይ ትኩረት እናድርግ",
      "medium": "ሊታወቅ የሚገባው"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "በአሁኑ ጊዜ ምንም የጤና ማስጠንቀቂያ የለም",
    "noAlertsDesc": "ጥሩ ጤናማ ልማዶችን እየተከተሉ ነው። ቀጥሉበት!",
    "whatYouCanDo": "ምን ማድረግ ይችላሉ፦",
    "viewMealSuggestions": "የተዘጋጁ የምግብ ጥቆማዎችን ይመልከቱ"
  },
  "engagement": {
    "currentStreak": "የአሁኑ ተከታታይ ቀናት",
    "bestStreak": "ምርጥ ተከታታይ ቀናት",
    "thisWeek": "በዚህ ሳምንት",
    "exerciseDays": "የአካል ብቃት እንቅስቃሴ ቀናት",
    "hydrationDays": "ውሃ የመጠጣት ቀናት",
    "healthMetricsLogged": "የተመዘገቡ የጤና መለኪያዎች",
    "weeklyGoalsProgress": "የሳምንታዊ ግቦች ሂደት",
    "completed": "ተጠናቋል",
    "days": "ቀናት",
    "keepGoing": "ይቀጥሉ!",
    "personalRecord": "የግል ስኬት!",
    "goalMet": "ግብዎ ተሳክቷል!"
  },
  "reminders": {
    "title": "የጤና ማስታወሻዎች",
    "subtitle": "ለእርስዎ በሚሆኑ የጤና ማሳወቂያዎች ጉዞዎን ይቀጥሉ",
    "breakfast": "የቁርስ ማስታወሻ",
    "lunch": "የምሳ ማስታወሻ",
    "dinner": "የእራት ማስታወሻ",
    "water": "የውሃ አወሳሰድ",
    "movement": "የእንቅስቃሴ እረፍት",
    "sleep": "የእንቅልፍ ማስታወሻ",
    "wellness": "የጤና ምርመራ",
    "healthLogging": "የጤና መረጃ ምዝገባ",
    "annualCheckup": "የአመት ምርመራ",
    "enable": "አግብር",
    "disable": "አጥፋ",
    "customize": "ጊዜ ያስተካክሉ",
    "stayConsistent": "በዘመናዊ ማስታወሻዎች ጤናዎን ይጠብቁ",
    "setupFriendly": "ጤናማ ልማዶችን ለመገንባት እንዲረዱዎት ጓደኛ የሆኑ ማስታወሻዎችን ያዘጋጁ።",
    "customizeWhen": "እያንዳንዱን ማስታወሻ መቼ እና ምን ያህል ጊዜ ማግኘት እንደሚፈልጉ ማስተካከል ይችላሉ።",
    "supportive": "አይጨነቁ - ማስታወሻዎቹ አጋዥ እንጂ የማይረብሹ እንዲሆኑ እናደርጋለን! 💚",
    "noPreferences": "ምንም የማስታወሻ ምርጫዎች አልተገኙም",
    "noPreferencesDesc": "የማስታወሻ ቅንብሮችዎን መጫን አልቻልንም። ምናልባት ለመጀመሪያ ጊዜዎ ስለሆነ ወይም ምርጫዎችን በመጫን ላይ ችግር ስላለ ሊሆን ይችላል።",
    "retryLoading": "እንደገና ሞክር",
    "saveSettings": "ቅንብሮችን አስቀምጥ",
    "saving": "በመቀመጥ ላይ..."
  },
  "empty": {
    "startJourney": "የጤና ጉዞዎን ይጀምሩ",
    "startJourneyDesc": "የጤና ጉዞዎን ዛሬ ይጀምሩ! የግል መረጃዎችን ለማግኘት እና ጤናዎን ለመከታተል ምን እንደሚሰማዎት ያጋሩ።",
    "completeFirstCheckIn": "የመጀመሪያውን ምርመራ ያጠናቅቁ",
    "stayOnTrack": "መደበኛነትዎን ይጠብቁ",
    "stayOnTrackDesc": "ልማድዎን በቋሚነት ይቀጥሉ 💊 ማስታወሻዎችን እና ድጋፍን ለማግኘት መድኃኒቶችዎን ይጨምሩ።",
    "addFirstMedication": "የመጀመሪያውን መድኃኒት ይጨምሩ",
    "learnMedicationSafety": "ስለ መድኃኒት ደህንነት ይወቁ",
    "buildMealLibrary": "የምግብ ማከማቻዎን ይገንቡ",
    "buildMealLibraryDesc": "እስካሁን ምንም ተወዳጅ ምግቦች የሉም። ለቀጣይ ፈጣን አጠቃቀም የሚወዷቸውን ምግቦች ያስቀምጡ።",
    "exploreMealOptions": "የምግብ አማራጮችን ያስሱ",
    "insightsAwait": "መረጃዎች ይጠብቁዎታል",
    "insightsAwaitDesc": "ለእርስዎ የተዘጋጁ የጤና መረጃዎችን እና የሁኔታ ትንታኔዎችን ለማግኘት የእለት ተእለት ምርመራዎችን ያጠናቅቁ።",
    "startDailyCheckIn": "የእለት ምርመራ ይጀምሩ",
    "learnAboutInsights": "ስለ ጤና መረጃዎች ይወቁ",
    "buildingStory": "የጤና ታሪክዎን እየገነቡ ነው",
    "buildingStoryDesc": "እስካሁን ምንም ያለፈ መረጃ የለም። የእለት ተእለት ምርመራዎን ሲያጠናቅቁ የእርስዎ የጤና ሁኔታ እና ለውጦች እዚህ ይታያሉ።",
    "completeCheckIn": "ምርመራውን ያጠናቅቁ",
    "tipComplete7Days": "ምክር፦ ትርጉም ያላቸው የጤና ለውጦችን ለማየት ለ7 ቀናት ምርመራዎችን ያጠናቅቁ።",
    "startTrackingHabits": "ጤናማ ልማዶችን መከታተል ይጀምሩ",
    "startTrackingHabitsDesc": "እስካሁን ምንም ልማዶች አልተመዘገቡም። ትናንሽ የእለት ተእለት እርምጃዎች ዘላቂ የጤና ለውጥ ያመጣሉ። ዛሬ ጤናማ ልማድዎን መገንባት ይጀምሩ።",
    "trackFirstHabit": "የመጀመሪያውን ልማድ ይከታተሉ",
    "getMoving": "መንቀሳቀስ ይጀምሩ",
    "getMovingDesc": "እስካሁን ምንም እንቅስቃሴ አልተመዘገበም። የ10 ደቂቃ እንቅስቃሴ እንኳን ስሜትዎን እና ጉልበትዎን ሊያነቃቃ ይችላል።",
    "logActivity": "እንቅስቃሴ ይመዝግቡ",
    "allCaughtUp": "ሁሉንም ጨርሰዋል!",
    "allCaughtUpDesc": "አዲስ ማሳወቂያ የለዎትም። ለአዳዲስ መረጃዎች እና የጤና ማስታወሻዎች ቆይተው ይመለሱ።",
    "noResultsFound": "ምንም ውጤት አልተገኘም",
    "noResultsFoundDesc": "ለ \"{query}\" የተገኘ ውጤት የለም። ፍለጋዎን ለማስተካከል ይሞክሩ ወይም ሌሎች አማራጮችን ያስሱ።"
  },
  "footer": {
    "tagline": "በ AI የታገዘ የእርስዎ የጤና ጥበቃ ረዳት",
    "builtWith": "ለጤናዎ ጉዞ በጥንቃቄ የተዘጋጀ",
    "allRightsReserved": "መብቱ በህግ የተጠበቀ ነው።",
    "about": "ስለ እኛ",
    "privacy": "ግላዊነት",
    "terms": "ውሎች",
    "contact": "ያግኙን",
    "helpCenter": "የእርዳታ ማዕከል"
  },
  "modals": {
    "feedback": {
      "title": "አስተያየትዎን ያጋሩ",
      "subtitle": "HealthLoop ን ለማሻሻል ይርዱን",
      "whatWorking": "ምን ጥሩ እየሰራ ነው?",
      "whatImprove": "ምን ማሻሻል እንችላለን?",
      "placeholder": "ሀሳብዎን እዚህ ያጋሩ...",
      "thankYou": "ለአስተያየትዎ እናመሰግናለን!",
      "submitted": "የእርስዎ አስተያየት HealthLoop ን የተሻለ ለማድረግ ይረዳናል።"
    },
    "reportProblem": {
      "title": "ችግር ያሳውቁ",
      "subtitle": "ስህተቶችን እንድንጠግንና መተግበሪያውን እንድናሻሽል ይርዱን",
      "describe": "ችግሩን ይግለጹ",
      "placeholder": "ምን ተፈጠረ? እባክዎ በተቻለ መጠን በዝርዝር ይግለጹ...",
      "optional": "አማራጭ፡ ችግሩ የተከሰተባቸው ቅደም ተከተሎች",
      "stepsPlaceholder": "1. እዚህ ላይ ተጫንኩ...\n2. ከዚያም...",
      "thankYou": "ሪፖርት ስላደረጉ እናመሰግናለን!",
      "submitted": "ይህንን ጉዳይ ወዲያውኑ እንመለከተዋለን።"
    },
    "mealPreferences": {
      "title": "የምግብ ምርጫዎን ያስተካክሉ",
      "subtitle": "ስለ ምግብ ምርጫዎችዎ ይንገሩን",
      "cuisines": "ተመራጭ የምግብ አይነቶች",
      "selectCuisines": "የሚፈልጉትን ሁሉ ይምረጡ",
      "dietary": "የአመጋገብ ምርጫዎች",
      "selectDietary": "የአመጋገብ ፍላጎቶችዎን ይምረጡ",
      "allergies": "አለርጂዎች እና ገደቦች",
      "allergiesPlaceholder": "ለምሳሌ፦ ለውዝ፣ የባህር ምግቦች፣ ግሉተን",
      "save": "ምርጫዎችን አስቀምጥ",
      "saving": "በማስቀመጥ ላይ..."
    },
    "upgrade": {
      "title": "ወደ ፕሪሚየም ያሳድጉ",
      "subtitle": "ሁሉንም አገልግሎቶች ያግኙ",
      "features": "የፕሪሚየም አገልግሎቶች",
      "getStarted": "ይጀምሩ",
      "learnMore": "ተጨማሪ ይወቁ"
    }
  },
  "login": {
    "title": "የእርስዎ የቅድመ-ጤና ጥበቃ መረጃ መድረክ",
    "subtitle": "ችግሮች ከመባባሳቸው በፊት ይከታተሉ፣ ይማሩ እና እርምጃ ይውሰዱ። ለቅድመ ጥበቃ፣ ለትምህርት እና ለደህንነት ተብሎ የተገነባ።",
    "email": "ኢሜይል",
    "password": "የይለፍ ቃል",
    "signIn": "ይግቡ",
    "signingIn": "በመግባት ላይ...",
    "forgotPassword": "የይለፍ ቃል ረሱ?",
    "noAccount": "መለያ የለዎትም?",
    "createAccount": "አዲስ ይፍጠሩ",
    "biometricLogin": "በጣት አሻራ ወይም በFace ID ይግቡ",
    "biometricHelper": "የጣት አሻራን፣ Face ID ወይም Windows Hello ን ይጠቀሙ",
    "authenticating": "በማረጋገጥ ላይ...",
    "vendorPartner": "የአጋር አቅራቢ ነዎት?",
    "vendorLogin": "የአቅራቢ መግቢያ",
    "emailRequired": "እባክዎ መጀመሪያ ኢሜይልዎን ያስገቡ",
    "biometricSuccess": "በተሳካ ሁኔታ ገብተዋል! 🎉",
    "noPasskeys": "የባዮሜትሪክ መግቢያ አልተዋቀረም። እባክዎ መጀመሪያ በይለፍ ቃል ይግቡ።",
    "biometricCancelled": "የባዮሜትሪክ መግቢያ ተሰርዟል",
    "biometricFailed": "ባዮሜትሪክ መግቢያ አልተሳካም። እባክዎ በይለፍ ቃል ይሞክሩ።"
  },
  "register": {
    "title": "HealthLoop ን ይቀላቀሉ",
    "subtitle": "የቅድመ-ጤና ጥበቃ ጉዞዎን ዛሬ ይጀምሩ",
    "fullName": "ሙሉ ስም",
    "email": "ኢሜይል",
    "password": "የይለፍ ቃል",
    "confirmPassword": "የይለፍ ቃል ያረጋግጡ",
    "createAccount": "መለያ ይፍጠሩ",
    "haveAccount": "መለያ አለዎት?",
    "signIn": "ይግቡ",
    "creating": "መለያ በመፍጠር ላይ...",
    "passwordTooShort": "የይለፍ ቃል ቢያንስ 8 ፊደላት መሆን አለበት",
    "setupBiometric": "የባዮሜትሪክ መግቢያ ያዋቅሩ",
    "setupBiometricDesc": "ለፈጣን እና ደህንነቱ የተጠበቀ አጠቃቀም የጣት አሻራን፣ Face ID ወይም Windows Hello ን ይጠቀሙ",
    "setupNow": "አሁኑኑ ያዋቅሩ",
    "skipForNow": "ለጊዜው ይለፉ",
    "settingUp": "በማዋቀር ላይ...",
    "benefit1": "የሚታወስ የይለፍ ቃል አያስፈልግም",
    "benefit2": "በባዮሜትሪክ ማረጋገጫ የላቀ ደህንነት",
    "benefit3": "በአንድ ንክኪ ወይም እይታ ብቻ ይግቡ",
    "biometricPrivacy": "የእርስዎ ባዮሜትሪክ መረጃ ከመሣሪያዎ አይወጣም",
    "biometricSuccess": "የባዮሜትሪክ መግቢያ በተሳካ ሁኔታ ተዋቅሯል! 🎉",
    "biometricFailed": "የባዮሜትሪክ መግቢያን ማዋቀር አልተቻለም። ቆይተው በቅንብሮች ውስጥ ማስተካከል ይችላሉ።",
    "biometricSetupLater": "በኋላ ላይ በመገለጫ ቅንብሮችዎ ውስጥ የባዮሜትሪክ መግቢያን ማዋቀር ይችላሉ"
  },
  "womensHealthPage": {
    "title": "የሴቶች ጤና መከታተያ",
    "subtitle": "የወር አበባ ዑደትዎን፣ ምልክቶችን እና ደህንነትዎን ይከታተሉ",
    "cycleOverview": "የዑደት አጠቃላይ እይታ",
    "currentPhase": "ያሉበት ደረጃ",
    "nextPeriod": "የሚቀጥለው የወር አበባ የሚጠበቅበት ቀን",
    "logPeriod": "የወር አበባ ይመዝግቡ",
    "logSymptoms": "ምልክቶችን ይመዝግቡ",
    "insights": "የዑደት ግንዛቤዎች",
    "tips": "እንደ ደረጃው የሚሰጡ ምክሮች",
    "history": "የወር አበባ ታሪክ",
    "noData": "እስካሁን ምንም የዑደት መረጃ የለም",
    "noDataDesc": "ለእርስዎ የተዘጋጁ ግንዛቤዎችን እና ትንበያዎችን ለማግኘት የዑደትዎን ክትትል ይጀምሩ።",
    "startTracking": "ክትትል ይጀምሩ"
  },
  "notifications": {
    "title": "ማሳወቂያዎች",
    "markAllRead": "ሁሉንም እንደተነበበ ምልክት አድርግ",
    "noNotifications": "አዲስ ማሳወቂያ የለም",
    "viewAll": "ሁሉንም ይመልከቱ"
  },
  "familyHealth": {
    "title": "የቤተሰብ እና የልጆች ጤና",
    "subtitle": "ለመላው ቤተሰብዎ የቅድመ-ጤና ጥበቃ ድጋፍ",
    "tabImmunizations": "ክትባቶች",
    "tabEducation": "ትምህርት",
    "tabReminders": "ማሳሰቢያዎች",
    "tabPlanner": "የቤተሰብ እቅድ",
    "immunizations": {
      "title": "የክትባት ግንዛቤ",
      "subtitle": "ስለሚመከሩ ክትባቶች መረጃ ያግኙ",
      "recommendedSchedule": "የሚመከር የክትባት መርሃ ግብር",
      "byAge": "በእድሜ ክልል",
      "infants": "ህፃናት (0-12 ወራት)",
      "toddlers": "ታዳጊዎች (1-3 ዓመት)",
      "preschool": "ቅድመ-ትምህርት ቤት (4-6 ዓመት)",
      "schoolAge": "የትምህርት ቤት እድሜ (7-12 ዓመት)",
      "teens": "ወጣቶች (13-18 ዓመት)",
      "adults": "አዋቂዎች",
      "learnMore": "ተጨማሪ ይወቁ",
      "consultDoctor": "ለእርስዎ ተስማሚ የክትባት ምክር ለማግኘት ሁልጊዜ የጤና ባለሙያዎን ያማክሩ",
      "upcomingReminders": "የሚቀጥሉ የክትባት ማሳሰቢያዎች",
      "noReminders": "ምንም የሚቀጥል የክትባት ማሳሰቢያ የለም",
      "addReminder": "የክትባት ማሳሰቢያ ያክሉ",
      "reminderFor": "ማሳሰቢያ ለ",
      "dueDate": "የሚወሰድበት ቀን",
      "notes": "ማስታወሻዎች",
      "markComplete": "እንደተጠናቀቀ ምልክት አድርግ"
    },
    "education": {
      "title": "የቤተሰብ ጤና ትምህርት",
      "subtitle": "በመረጃ ላይ የተመሰረቱ የቅድመ-ጤና ጥበቃ መረጃዎች",
      "categories": "ምድቦች",
      "infant": "የህፃናት እንክብካቤ",
      "child": "የልጆች እድገት",
      "nutrition": "አመጋገብ እና እድገት",
      "safety": "ደህንነት እና መከላከል",
      "mental": "የአእምሮ ደህንነት",
      "hygiene": "ንጽህና እና ልምዶች",
      "searchPlaceholder": "የጤና ርዕሶችን ይፈልጉ...",
      "popularTopics": "ታዋቂ ርዕሶች",
      "readMore": "ተጨማሪ ያንብቡ",
      "readTime": "ደቂቃ ንባብ"
    },
    "reminders": {
      "title": "የቤተሰብ ጤና ማሳሰቢያዎች",
      "subtitle": "ለመላው ቤተሰብ የቅድመ-ጤና እንክብካቤን ይከታተሉ",
      "createReminder": "ማሳሰቢያ ይፍጠሩ",
      "familyMember": "የቤተሰብ አባል",
      "reminderType": "የማሳሰቢያ አይነት",
      "frequency": "ድግግሞሽ",
      "activeReminders": "ንቁ ማሳሰቢያዎች",
      "upcomingThisWeek": "በዚህ ሳምንት የሚጠበቁ",
      "noActiveReminders": "ምንም ንቁ ማሳሰቢያ የለም",
      "types": {
        "checkup": "የጤና ምርመራ",
        "dental": "የጥርስ ህክምና ጉብኝት",
        "vision": "የዓይን ምርመራ",
        "vaccine": "ክትባት",
        "medication": "መድሃኒት",
        "custom": "ሌላ"
      }
    },
    "planner": {
      "title": "የቤተሰብ ጤና እቅድ አውጪ",
      "subtitle": "ለቤተሰብዎ የቅድመ-ጤና እንክብካቤን ያስተባብሩ",
      "addMember": "የቤተሰብ አባል ያክሉ",
      "memberName": "የአባል ስም",
      "relationship": "ዝምድና",
      "dateOfBirth": "የልደት ቀን",
      "viewCalendar": "ካላንደር ይመልከቱ",
      "upcomingCare": "የሚቀጥሉ የቅድመ-ጤና እንክብካቤዎች",
      "nothingScheduled": "እስካሁን ምንም አልተያዘም",
      "scheduleCheckup": "ምርመራ ቀጠሮ ይያዙ",
      "relationships": {
        "child": "ልጅ",
        "spouse": "የትዳር አጋር",
        "parent": "ወላጅ",
        "sibling": "ወንድም/እህት",
        "other": "ሌላ"
      }
    },
    "content": {
      "infantCare": {
        "title": "የህፃናት ቅድመ-ጤና እንክብካቤ",
        "intro": "ለልጅዎ የመጀመሪያ ዓመት አስፈላጊ የጤና ጥበቃ ልምዶች",
        "topics": [
          "የህፃናት ጤና ምርመራ መርሃ ግብር",
          "ሊታዩ የሚገባቸው የእድገት ደረጃዎች",
          "ደህንነቱ የተጠበቀ የእንቅልፍ ልምዶች",
          "አመጋገብ እና ጡት ማጥባት",
          "የክትባት መርሃ ግብር"
        ]
      },
      "childDevelopment": {
        "title": "የልጆች እድገት እና ደረጃዎች",
        "intro": "ጤናማ እድገትን እና ለውጦችን መረዳት",
        "topics": [
          "የአካል እድገት ደረጃዎች",
          "ማህበራዊ እና ስሜታዊ እድገት",
          "የቋንቋ እድገት",
          "የአስተሳሰብ እድገት",
          "ሀኪም ማማከር የሚገባዎት መቼ ነው"
        ]
      },
      "nutrition": {
        "title": "አመጋገብ እና ጤናማ እድገት",
        "intro": "ከመጀመሪያው ጀምሮ ጤናማ የአመጋገብ ልምዶችን መገንባት",
        "topics": [
          "ከእድሜ ጋር የሚመጣጠን አመጋገብ",
          "ጤናማ የቁርስ ሀሳቦች",
          "ምግብ የሚመርጡ ህፃናትን መያዝ",
          "የምግብ ደህንነት መሰረታዊ ነገሮች",
          "የፈሳሽ አወሳሰድ መመሪያዎች"
        ]
      },
      "safety": {
        "title": "ደህንነት እና ጉዳት መከላከል",
        "intro": "ለቤተሰብዎ ደህንነቱ የተጠበቀ አካባቢ መፍጠር",
        "topics": [
          "የቤት ደህንነት ማረጋገጫ ዝርዝር",
          "የመኪና ውስጥ የህፃናት መቀመጫ ደህንነት",
          "የውሃ ደህንነት",
          "መርዛማ ነገሮችን መከላከል",
          "ለድንገተኛ አደጋ መዘጋጀት"
        ]
      }
    }
  }
};
